import {Validator} from 'vee-validate';
import {BasicSelect} from 'vue-search-select';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
 import DatePicker from 'vue2-datepicker';
import CustomExpandableTable from '../../../../../shared/components/customExpandableTable';
import TripShipment from './../TripShipment';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import depsCloseTrip from './../depsCloseTrip';
import TripServices from './../../../../../firstAndLastmilemanagement/services/firstAndLastmilemanagement.service';
import CONSTANT from './../../../../../shared/constants/constant';
import iptracker from '../../../../../../views/components/commonfunction/iptracker';
import Utility from './../../../../../utility/services/utility.service';
import axios from 'axios';
// import 'viewerjs/dist/viewer.css'
// import { component as Viewer } from "v-viewer"
import Multiselect from 'vue-multiselect'

export default {
  name: 'createTripManagement',
  components: {
    BasicSelect,
    DatePicker,
    CustomExpandableTable,
    depsCloseTrip,
    TripShipment,
    Treeselect,
    VueElementLoading,
    CONSTANT,
    TripServices,
    iptracker,
    Multiselect
  },

  props:['parentObj'],

  data() {
    return {
      AWBLengthLimit: CONSTANT.AWB_LENGTH_LIMIT,
      MPSLengthLimit: CONSTANT.MPS_LENGTH_LIMIT,
      isBasicInfoLoading: false,
      scanAWB: '',
      scanMPS: '',
      scanDeliveredAWB: '',
      scanUndeliveredAWB: '',
      scanUndeliveredMPS: '',
      offset: 0,
      Subexpanded: false,
      awbErr: '',
      currentTab: 'firstmile',
      tripData: '',
      tmstripid: '',
      awbToBeScannedFM: 0,
      awbToBeScannedLM: 0,
      awbScannedFM: 0,
      awbScannedLM: 0,
      isListingLoaded: false,
      firtmileDocumentData: [],
      lastmileDocumentData: [],
      physicalInvoiceErr: '',
      firstmileMPSData: [],
      lastmileMPSData: [],
      documentCountFM: 0,
      mpsCountFM: 0,
      documentCountLM: 0,
      mpsCountLM: 0,
      shipmentType: "",
      lmShipmentType: '',
      lmPhysicalInvoices: '',
      podalreadyuploadErr: '',
      lmPhysicalInvoiceErr: '',
      isAWBScanning: false,
      isMPSScanning: false,
      undeliveredAWBErr: '',
      reasonSearch: null,
      podDetail: [],
      podImage: '',
      reasonlist: [],
      PODQC: "",
      imageRequired: 0,
      ODOErr: '',
      closeTripData: '',
      accordianTab: { 1: false, 2: false, 3: false },
      selectedAWB: [{
        "AWB": '',
        "Cash": '',
        "collectibleData": {
          filename: '',
          filepath: {
            Location: ''
          }
        },
      }],
      cashcollection: '',
      cashcollected: '',
      collectibledocument: {},
      collectibledoc: '',
      subaccordianTab: { 1: false, 2: false },
      expanded: false,
      showDepartTrip: false,
      depscloseTrip: false,
      VehicleCloseODOreading: '',
      physicalInvoices: "",
      ScanPalletFM: "",
      ScanPalletLM: "",
      Comments: "",
      tripStatus: '',
      scanDeliveredAWBErr: '',
      podQCErr: '',
      reasonErr: '',
      lastMpsAwbScannedData: '',
      isPalletScanCompulsory: "",
      isFMPalletScan: true,
      isLMPalletScan: true,
      fmScanPalletErr: '',
      lmScanPalletErr: '',
      showShipmentDropDown: [],
      modifyphysicalinvoice: [],
      invoiceerr: [],
      showTable: true,
      imagearray: [],
      defaultscanflag: '', //1 for AWB and 2 for MPS
      scantype: "",
      maxcomment: 50,
      imageerr: '',
      Loading: false,
      disableflag: false,
      imageLoader: false,
      ODOhidden: false,
      showCloseTripModal: false,
      AWBArr: [],
      MPSArr: [],
      MPSList: [],
      FTCAWB: [],
      FTCCashmemo: [],
      userdetail: {},
      ODOhidden: false,
      imgOpenFlag: false,
      badReason: '',
      selectedRemark: [],
      selectedBadRemarks: [],
      podRemarkArray: [],
      saveDetailsFlag: false,
      viewpod: false,
      viewpodErr: '',
      showMPS: false,
      modalData: '',
      dwsinscanawbarr: [],
      dwsawbpayload: [],
      dwsinscanawbarr: [],
      dwsawbpayload: [],
      tobescanawbarr: [],
      tobescanmpsarr: [],
      alertmsg: '',
      firstmileInvoiceData: [],
      invoiceAwb: '',
      addAwb: [],
      invoiceAwb: [],
      awbError: '',
      subtabdisabledflag: false,
      checkemptyawb: true,
      pendingInvoice: [],
      previewImageUrl: "",
      zoom: 1,
      rotation: 0,
      showImageFlag: false,
      scanDocumentMdlFlag: false,
      isScannerImageLoading: false,
      mediaStream: null,
      defaultImage: 'https://live-podimage.s3.ap-south-1.amazonaws.com/DocFile/94371190613854_P0.png',
      imageData: {
        image: '',
        image_orientation: 0
      },
      capturePhotoMdlFlag: false,
      viewCamera: false,
      images: [
        'https://live-podimage.s3.ap-south-1.amazonaws.com/DocFile/94371190613854_P0.png'

      ],
      viewScannedImage: false,
      printerList: [],
      scannerList :[],
      selectedCamera: null,
      selectedScanner: null,
      desiredWidth: 1600,
      desiredHeight: 1200,
      selectedCaptureImage: null,
      imageBlob: null,
      selectedStatus1: null,
      temppodStatusArray: [{
        id: 1,
        label: "good"
      },
      {
        id: 2,
        label: "bad"
      }
      ],
      selectedPodQc: [],
      selectedStatus1: [],
      uploadShippingImage1: '',
      uploadBrowsePodImageMdlFlag: false,
      viewUploadedImage: false,
      uploadImageEvent: '',
      showImage: false,
      selectedPodImage: [],
      selectedImages: [],
      currentIndex: 0,
      displayViewImage: false,
      selectedBrowsedFileArray: [],      
      //Camera modal
      selectedCameraCapturedPodImage: [],
      displayCameraCapturedImages: false,      
      //Scanner Images
      selectedPodImagesByScanner: [],
      displayScannerImages: false,
      isGetDeviceLoader: false,
      previewScannerImageUrl : '',
      isCameraImageLoader : false,
      showNotes: true,
      showTooltip: false,

      allCapturedPodImagesArray: [],
      viewUploadedPodImages: false,
      viewCapturedPodsImageSrc: '',
      viewCapturedPodLoader: false,
      podPayloadToSaveInDb: {},
      selectedTableRowDataArray: '',
      podBadRemarkComments: {},
      disabledDeleteImageButton:[],
      disableBrowseImageButton: [],
      disableCameraImageButton: [],
      disableScannerImageButton: [],
      enableDeleteImageDisableClass:[],
      enableBrowseImageDisableClass: [],
      enableCameraImageDisableClass: [],
      enableScannerImageDisableClass: [],
      enableActionItems: [],
      disableAction: [],
      disableClassForPodReason: [],
      enablePodResonDropdown: [],
      viewBrowseImageUploadButton: false,
      viewCameraImageUploadButton: false,
      viewScannerImageUploadButton: false,
      selectedRowIndex: 0,
      isGetDeviceLoader: false,
      commentLoader: false,
      badRemarkShippingId: '',
      badPodComment: [],
      viewpodCommentModal: false,
      currentSelectedRemark: '',
      currentSelectedRemarkDetails: {},
      selectedAllImages: [],
      podReviewFieldImageStatus: false,
      uploadHubImageStatus: null,
      podDetail : [{
        "awb" : '',
        "podqc": null,
        "badpodreason": '',
        "comments": '',
        "shipmenttag":'',
        "reviewstatus": '',
        "podurl": '',
        "uploadedPod": [],
        "selectedBrowsedPodsToUploadS3": [],
        "selectedBrowsedPodsToUploadS3Save": [],
        "selectedScannedPodsToUploadS3": [],
        "selectedCameraPodsToUploadS3":[],
        "error": false,
        "showAllOptions": false,
        "presignHubImage": [],
        "documentscanned": 0,
        "uploadedHubImage": [],
        "disableBrowseImageButton" : false,
        "disableCameraImageButton" : false,
        "disableScannerImageButton": false,
        "disabledDeleteImageButton": false,
        "isdeliverywopod": 0,
        "isreuploadrequired": 0,
        "podUploadStatus":0
      }],
      maxDisplayedOptions: 5,
      disabledSaveDeliveredPodBtn: false,
      notReviewedHubImageShipmentArray: [],
      disabledActionButtonDiv: false,
      disabledLmCloseTrip: false,
      viewUploadedHubImages: [] ,   
      viewAdditionalDocImage: [],    
      toalDeliveredPod : 0,
      totalScannedAwb : 0,
      remainingAwb : 0
      
    }
  },
  beforeDestroy() {
	if(this.alertmsg!=''){
		this.alertmsg.dismiss();
	}
  },
  computed: {
    isPodSubmitDisabled() {
      return this.podDetail.some(row => row.error);
    }
  },
  async mounted() {
    document.addEventListener('keydown', this.closeOpenModals);
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userdetail = userdetail;
    this.userName = userdetail.email;
    this.defaultHubID = userdetail.hubID[0];
    this.getTripData()
    this.getAWBDataForCloseTrip()
    this.getToBeScannedCountForAWB()
    this.getMPSDataForCloseTrip()
    this.getToBeScannedCountForMPS()
    this.getBadPODReason()
    this.getInvoiceData()
    // this.fetchCameraList()
    this.fetchScannerList()
  },
  methods: {
    badResonDeselect(index, $event) {
      let parts = this.podDetail[this.selectedRowIndex].comments.split(',');
      let commentText = ''
      if ($event.id == 4) {
        commentText = 'Upload Document'
      } else {
        commentText = $event.label
      }
      let modifiedParts = parts.filter(part => !part.startsWith(`${commentText}:`));
      let resultString = modifiedParts.join(',');
      this.podDetail[this.selectedRowIndex].comments = resultString
    },
    toggleShowAllOptions(index) {
      this.$set(this.podDetail, index, {
        selectedOptions: this.podDetail[index].badpodreason,
        showAllOptions: !this.podDetail[index].showAllOptions,
      });
    },
    closePodCommentModal() {
      let currentValue = this.currentSelectedRemarkDetails.event.id
      let currentIndex = this.currentSelectedRemarkDetails.index 
      this.viewpodCommentModal = false;
              this.commentLoader = false
  
  },
    async savePodComment() {
      this.commentLoader = true
      if (this.badPodComment == "") {
          this.$alertify.error("Please Enter Comments")
          this.commentLoader = false
          return false
      }
      let commentKey = ''
      if (this.currentSelectedRemarkDetails.event.id == 4) {
        commentKey = "Upload Document"
      } else {
        commentKey = this.currentSelectedRemarkDetails.event.label
      }
      let commentObject = `${commentKey}:${this.badPodComment}`

      this.podDetail[this.selectedRowIndex].comments = this.podDetail[this.selectedRowIndex].comments != 'NA' ? `${this.podDetail[this.selectedRowIndex].comments},${commentObject} `: commentObject
      // this.podBadRemarkComments[this.selectedRowIndex] = this.podBadRemarkComments[this.selectedRowIndex] ? `${this.podBadRemarkComments[this.selectedRowIndex]},${commentObject}` : commentObject
      this.$alertify.success("Comments Added Successfully")
      this.viewpodCommentModal = false
      this.badPodComment = ""
      this.commentLoader = false
      this.commentLoader = false
  },
    viewPodFieldImages(podData, index) {
      if (podData && podData.podurl ) {
        this.$viewerApi({
          images: podData.podurl.destinationpodimg,
        })
      }
      this.podDetail[index].reviewstatus = true 
    },
    async viewPodHubImages(podData, index) {  
      let hubImagesArray = []
      if (this.podDetail[index].documentscanned == 3) {
        // hubImagesArray = this.podDetail[index].uploadedHubImage
        for (let i = 0; i < this.podDetail[index].uploadedHubImage.length; i++) {
          const element = this.podDetail[index].uploadedHubImage[i];
          let inputPayload = {
            filepath : element
          }
          let presignUrlData = await TripServices.generatePresignUrl(inputPayload)  
          if (presignUrlData && presignUrlData.data.code == 200) {
            hubImagesArray.push(presignUrlData.data.data)
          }
        }
      } else {
        for (let i = 0; i < this.podDetail[index].uploadedPod.length; i++) {
          const element = this.podDetail[index].uploadedPod[i];
          let inputPayload = {
            filepath : element
          }
          let presignUrlData = await TripServices.generatePresignUrl(inputPayload)
          if (presignUrlData && presignUrlData.data.code == 200) {
            hubImagesArray.push(presignUrlData.data.data)
          }
        }
      } 
      
      if (hubImagesArray.length > 0) {        
        this.viewAdditionalDocImage = hubImagesArray  
        this.$viewerApi({
          images: this.viewAdditionalDocImage,
        })
      } else {
        this.$alert('No Pod Uploaded', "", "error");
      }
    },
    checkAdditionalDoc(data) {
      let destinationImages = data ? data : []
      let validadditionalDoc = destinationImages.filter(Boolean);
      if (validadditionalDoc && validadditionalDoc.length >0) {
        return true
      } else {
        return false
      }
    },
    checkFieldImage(data) {
      let destinationImages = data.podurl.destinationpodimg ? data.podurl.destinationpodimg : []
      let validatedPodArray = destinationImages.filter(Boolean);
      if (validatedPodArray && validatedPodArray.length>0) {
        return true
      }
    },
    async viewAdditionalImages(additionalImageData, index) {  
      let hubImagesArray = []
      for (let i = 0; i < additionalImageData.length; i++) {
        const element = additionalImageData[i];
        let inputPayload = {
          filepath : element
        }
        let presignUrlData = await TripServices.generatePresignUrl(inputPayload)  
        if (presignUrlData && presignUrlData.data.code == 200) {
          hubImagesArray.push(presignUrlData.data.data)
        }
      }      
      if (hubImagesArray.length > 0) {        
        this.viewAdditionalDocImage = hubImagesArray  
        this.$viewerApi({
          images: this.viewAdditionalDocImage,
        })
      } else {
        this.$alert('No Pod Uploaded', "", "error");
      }
    },
    viewSinglePodImage(url) {
      this.viewCapturedPodsImageSrc = url
    },
    closeOpenModals(event) {
      if (event.key === 'Escape' || event.key === 'Esc') {
        // Close or hide the div
        this.uploadBrowsePodImageMdlFlag = false
        this.capturePhotoMdlFlag = false
        this.scanDocumentMdlFlag = false
        this.viewUploadedPodImages = false
      }
    },
    async OnClickDeletePod(rowData, index) {
      this.selectedRowIndex = index
      this.$confirm("Are you sure you want to delete the Pod's.", '', 'question').then(async () => {
        let allImage = [...this.podDetail[index].selectedBrowsedPodsToUploadS3,
                        ...this.podDetail[index].selectedCameraPodsToUploadS3,
          ...this.podDetail[index].selectedScannedPodsToUploadS3
        ]
        let uploadedS3Images = [
          ...this.podDetail[index].uploadedPod
        ]        
        if (allImage.length > 0) {
          // let payload = {
          //   podImages : uploadedS3Images
          // }
          // let result = await TripServices.deletePodImages(payload)
          this.podDetail[index].disableBrowseImageButton = false
          this.podDetail[index].disableCameraImageButton = false
          this.podDetail[index].disableScannerImageButton = false
          this.podDetail[index].selectedBrowsedPodsToUploadS3Save = []
          this.podDetail[index].selectedBrowsedPodsToUploadS3 = []
          this.podDetail[index].selectedScannedPodsToUploadS3 = []
          this.podDetail[index].selectedCameraPodsToUploadS3 = []       
          this.podDetail[index].presignHubImage = []
          this.viewUploadedHubImages = []
          this.selectedCameraCapturedPodImage = []
          this.selectedPodImagesByScanner = []
          this.selectedBrowsedFileArray = []
          this.selectedPodImage = []
          this.selectedAllImages = []
          this.podDetail[index].uploadedPod = []
          this.$alertify.success("All selected images are deleted successfully");
        } else {
          this.$alertify.error("Not Found any Images to Delete");
        }
      });     
    },
    podQcValidation(val, podQc, selectedBadRemark, comments, index) {  
      if (val.isdeliverywopod !=1) {
        if (val.reviewstatus == true) {
          if (podQc) {
            if (podQc == '2') {
              if (!selectedBadRemark || selectedBadRemark.length === 0) {
                const errorMessage = "User must select a bad pod reason if PodQC is bad";
                this.$alertify.error(errorMessage);
                return { valid: 0, message: errorMessage };
              } else {
                return {valid:1, message:'Valid Record'}
              }
            } else {
              return {valid:1, message:'Valid Record'}
            }
          } else {
            return {valid:0, message:'Select Pod Quality'}
          }
        } else {
          return {valid:0, message:"Please Review Field Image First"}
        }
      } else {
        if (podQc) {
          if (podQc == '2') {
            if (!selectedBadRemark || selectedBadRemark.length === 0) {
              const errorMessage = "User must select a bad pod reason if PodQC is bad";
              this.$alertify.error(errorMessage);
              return { valid: 0, message: errorMessage };
            } else {
              return { valid: 1, message: "Valid Record" };
            }
          } else {
            return {valid:1, message:'Valid Record'}
          }
        } else {
          return {valid:0, message:'Select Pod Quality'}
        }
      }
    
    },
    openBrowserUploadModal(val, podQc, selectedBadRemark, comments, index) {
      this.selectedRowIndex = index         
      this.previewImageUrl =""
      let validationResult = this.podQcValidation(val, val.podqc, val.badpodreason, val.comments,index)
      if (validationResult.valid) {
        this.viewBrowseImageUploadButton = this.podDetail[index].selectedBrowsedPodsToUploadS3.length>0 ? true : false
        this.selectedPodImage = this.podDetail[index].selectedBrowsedPodsToUploadS3
        this.selectedTableRowDataArray = val
        this.scanDeliveredAWB = val.awb
        this.Loader = false
        this.isScannerImageLoading = false
        this.uploadBrowsePodImageMdlFlag = true
      } else {
        this.$alertify.error(validationResult.message)
      }   
    },
    async openCapturePhotoModal(val, podQc, selectedBadRemark, comments, index) {
      this.selectedRowIndex = index
      this.selectedCamera = null
      this.isScannerImageLoading = false
      this.isCameraImageLoader =  false
      await this.fetchCameraList()  
      let validationResult = this.podQcValidation(val, val.podqc, val.badpodreason, val.comments,index)
      if (validationResult.valid) {
        this.viewCameraImageUploadButton = this.podDetail[index].selectedCameraPodsToUploadS3.length > 0 ? true : false
        this.selectedCameraCapturedPodImage = this.podDetail[index].selectedCameraPodsToUploadS3
        this.selectedTableRowDataArray = []
        this.selectedTableRowDataArray = val
        this.Loader = false
        this.capturePhotoMdlFlag = true
        this.isScannerImageLoading = false
        this.scanDeliveredAWB = val.awb
        // this.onclickCaptureImage()
      } else {
        this.$alertify.error(validationResult.message)
      }
    },
    async openScannerModal(val, podQc, selectedBadRemark, comments, index) {  
      this.selectedRowIndex = index    
      this.selectedScanner = null
      this.selectedPodImagesByScanner = this.podDetail[index].selectedScannedPodsToUploadS3
      let validationResult = this.podQcValidation(val, val.podqc, val.badpodreason, val.comments,index)
      if (validationResult.valid) {
        this.viewScannerImageUploadButton =  this.podDetail[index].selectedScannedPodsToUploadS3.length > 0 ? true : false
        this.selectedTableRowDataArray = []
        this.Loader = false
        this.isScannerImageLoading = false
        this.selectedTableRowDataArray = val
        this.scanDocumentMdlFlag = true
        this.scanDeliveredAWB = val.awb
      } else {
        this.$alertify.error(validationResult.message)
      }
    },
    closeImage() {
      this.showImage = false;
    },
    removeImage(index) {
      this.podDetail[this.selectedRowIndex].selectedBrowsedPodsToUploadS3.splice(index, 1)
      this.podDetail[this.selectedRowIndex].selectedBrowsedPodsToUploadS3Save.splice(index,1)
      this.previewImageUrl = ''
      this.selectedPodImage = this.podDetail[this.selectedRowIndex].selectedBrowsedPodsToUploadS3
      if (this.selectedPodImage.length <= 0) {
        this.viewBrowseImageUploadButton = this.podDetail[this.selectedRowIndex].selectedBrowsedPodsToUploadS3.length>0 ? true :false
        this.disabledActionButtonDiv = false
        this.displayViewImage = false
        this.previewImageUrl = ''
      }
    },
   
    viewImage(index) {
      this.disabledActionButtonDiv = true
      this.previewImageUrl = index
    },
    viewCameraImage(cameraimage) {
      this.disabledActionButtonDiv = true
      this.imageData.image =  cameraimage
    },
    viewScannerImage(ScannedImage) {
      this.disabledActionButtonDiv =  true
      this.previewScannerImageUrl = ScannedImage
    },
    closeBrowseUploadModal() {
      this.disabledActionButtonDiv = false
      if (this.podDetail[this.selectedRowIndex].selectedBrowsedPodsToUploadS3.length>0) {        
        this.viewBrowseImageUploadButton =true
      }
      this.uploadBrowsePodImageMdlFlag = false
      this.previewImageUrl = ''
      this.viewUploadedImage = false
      this.displayViewImage = false
      // this.selectedPodImage = []
    },
    closeViewUploadedImageModal() {
      this.viewUploadedPodImages = false
      this.previewImageUrl = ''
      this.viewUploadedImage = false
      this.uploadBrowsePodImageMdlFlag = false
      // this.selectedPodImage = []
    },
    addBrowsedPodImageInList() {
      this.selectedPodImage.push(this.previewImageUrl)
    },
    
    showScannerTooltip() {
      this.showTooltip = true
    },
    async BrowsePodImage(e) {
      this.disabledActionButtonDiv = true;
      this.selectedImages = []
      if (!/\.(jpg|png|jpeg)$/.test(e.target.files[0].name.toLowerCase())) {
          this.isLoading = false;
          this.$refs.files.value=null;
          return this.$alert('Selected File Format Is Incorrect.', "", "error");
      }
      if (this.podDetail[this.selectedRowIndex].selectedBrowsedPodsToUploadS3.length>2 || e.target.files.length >3) {
        this.isScannerImageLoading = false
        return this.$alert('You Can Select Only 3 Pod Images',"","error")
      }
      this.filename = e.target.files[0].name;
      this.isScannerImageLoading = true;
      this.selectedBrowsedFileArray = e.target.files;      
      this.podDetail[this.selectedRowIndex].selectedBrowsedPodsToUploadS3Save.push(...e.target.files)
      this.viewBrowseImageUploadButton = true
      for (let i = 0; i < this.selectedBrowsedFileArray.length; i++) {
        const file = this.selectedBrowsedFileArray[i];
        if (file.type.startsWith('image/')) {
          const imageUrl = URL.createObjectURL(file);
          this.previewImageUrl = imageUrl;          
          this.podDetail[this.selectedRowIndex].selectedBrowsedPodsToUploadS3.push(imageUrl)
          this.selectedPodImage = this.podDetail[this.selectedRowIndex].selectedBrowsedPodsToUploadS3;
          this.displayViewImage = true
        }
      }
      this.isScannerImageLoading = false;
     
    },
    async uploadBrowsedFilesInS3() {
      const element = this.podDetail[this.selectedRowIndex];
      if (element.documentscanned != 3) {
        // if (element.isdeliverywopod != 1) {
          if (this.podDetail[this.selectedRowIndex].selectedBrowsedPodsToUploadS3 && this.podDetail[this.selectedRowIndex].selectedBrowsedPodsToUploadS3.length > 0) {
            this.isListingLoaded = true
            let uploadFile = this.podDetail[this.selectedRowIndex].selectedBrowsedPodsToUploadS3Save
    
            this.imagearray = []
            let formData = new FormData();
            /*Add the form data we need to submit*/
            for (let key in uploadFile) {
              if (key >= 0) {
                if (uploadFile[key].type != "image/jpeg" &&
                  uploadFile[key].type != "image/jpg" && uploadFile[key].type != "image/png") {
                  this.$alertify.error("Please upload only valid file format");
                  this.isListingLoaded = false
                  return false
                }
              }
              if (key == 'length' && uploadFile[key] > 3) {
                this.$alertify.error("You Can Select Only 3 Pod Images");
                this.isListingLoaded = false
                return false
              }
              if (uploadFile[key].size > (1024 * 1024 * 3)) {
                this.$alert(`${uploadFile[key].name} size is greater than 3MB`, "", "error");
                this.isListingLoaded = false
                return false
              } else {
                formData.append("file", uploadFile[key]);
              }
            }
            formData.append("awb", this.scanDeliveredAWB);
            let result = await TripServices.UploadPODImage(formData)
            if (result.data.code == 200) {
              this.podDetail[this.selectedRowIndex].selectedCameraPodsToUploadS3 = []
              this.podDetail[this.selectedRowIndex].selectedScannedPodsToUploadS3 = []
              this.podDetail[this.selectedRowIndex].disabledDeleteImageButton=true
              this.podDetail[this.selectedRowIndex].disableBrowseImageButton = false
              this.podDetail[this.selectedRowIndex].disableCameraImageButton = true
              this.podDetail[this.selectedRowIndex].disableScannerImageButton = true
                this.isListingLoaded = false
                let tempPresignedArray = []
                let tempUploadPod = []
                result.data.data.map(obj => {
                  this.imagearray.push(obj.Location)
                  tempUploadPod.push(obj.Location)              
                  tempPresignedArray.push(obj.PresignUrl)
                })
              
              this.$alertify.success("Images uploaded successfully !");
              this.podDetail[this.selectedRowIndex].uploadedPod = tempUploadPod
              this.podDetail[this.selectedRowIndex].presignHubImage = tempPresignedArray
              this.uploadHubImageStatus = this.selectedRowIndex
              this.viewBrowseImageUploadButton = false
              this.imageerr = ''    
              let saveResult = await this.saveDeliveredSinglePodDetails(this.selectedRowIndex)
              this.previewImageUrl = ''
              this.isListingLoaded = false
              this.uploadBrowsePodImageMdlFlag = false
            }
            else {
              this.$alertify.error("Images could not be uploaded.");
              this.isListingLoaded = false
            }
            if (!this.podPayloadToSaveInDb[this.scanDeliveredAWB]) {
              console.log("");
              this.podPayloadToSaveInDb[this.scanDeliveredAWB] = { awb:this.scanDeliveredAWB,podQc:this.selectedTableRowDataArray.podqc,badpodreason:this.selectedTableRowDataArray.badpodreason,comments:this.selectedTableRowDataArray.comments,podimages:this.imagearray };
            } else {
              console.log("Key ALready Exits");
            }
            console.log("this.podPayloadToSaveInDb",this.podPayloadToSaveInDb);
            this.isListingLoaded = false
          }
          else {
            this.isListingLoaded = false
            this.$alertify.error("Please Select POD Images");
          }
        // }
      }
     
      this.isListingLoaded = false
    }, 
    async uploadScannerCapturedBinaryImage() {
      let images = this.podDetail[this.selectedRowIndex].selectedScannedPodsToUploadS3
      if (images && images.length > 0) {
        this.isGetDeviceLoader = true
        let uploadFile = this.podDetail[this.selectedRowIndex].selectedScannedPodsToUploadS3;
        this.imagearray = []
        let formData = new FormData();
        for (let key in uploadFile) {
          var binaryData = uploadFile[key]            
              formData.append("file", binaryData);
          }
          formData.append("awb", this.scanDeliveredAWB);
          let result = await TripServices.UploadCameraBinaryImage(formData)
        if (result.data.code == 200) {
          this.viewScannerImageUploadButton = false
          this.podDetail[this.selectedRowIndex].selectedCameraPodsToUploadS3 = []
          this.podDetail[this.selectedRowIndex].selectedBrowsedPodsToUploadS3 = []
          this.podDetail[this.selectedRowIndex].disabledDeleteImageButton=true
          this.podDetail[this.selectedRowIndex].disableBrowseImageButton = true
          this.podDetail[this.selectedRowIndex].disableCameraImageButton = true
          this.podDetail[this.selectedRowIndex].disableScannerImageButton = false
            this.isGetDeviceLoader = false
            let tempPresignedArray = []
            let tempUploadedImages = []
            result.data.data.map(obj => {
              this.imagearray.push(obj.Location)
              tempUploadedImages.push(obj.Location)
              this.allCapturedPodImagesArray.push(obj.PresignUrl)
              tempPresignedArray.push(obj.PresignUrl)
              this.uploadHubImageStatus = this.selectedRowIndex
            })
            this.uploadHubImageStatus = this.selectedRowIndex
            this.podDetail[this.selectedRowIndex].uploadedPod = tempUploadedImages
            this.podDetail[this.selectedRowIndex].presignHubImage = tempPresignedArray
            this.$alertify.success("Images uploaded successfully !");
            await this.saveDeliveredSinglePodDetails(this.selectedRowIndex)
          this.imageerr = ''
          this.isGetDeviceLoader = false
          this.scanDocumentMdlFlag = false
          }
          else{
            this.$alertify.error("Images could not be uploaded.");
            this.isGetDeviceLoader = false
        }
        if (!this.podPayloadToSaveInDb[this.scanDeliveredAWB]) {
          console.log("");
          this.podPayloadToSaveInDb[this.scanDeliveredAWB] = { awb:this.scanDeliveredAWB,podQc:this.selectedTableRowDataArray.podqc,badpodreason:this.selectedTableRowDataArray.badpodreason,comments:this.selectedTableRowDataArray.comments,podimages:this.imagearray };
        } else {
          console.log("Key ALready Exits");
        }
          this.isGetDeviceLoader = false
      }
      else{
        this.isGetDeviceLoader = false
        this.$alertify.error("Please Select Pod Images");
        // this.awbErr = 'Please Scan AWB'
      }
      this.isGetDeviceLoader = false
    }, 
    async uploadCameraCapturedBinaryImage() {
      if (this.podDetail[this.selectedRowIndex].selectedCameraPodsToUploadS3 && this.podDetail[this.selectedRowIndex].selectedCameraPodsToUploadS3.length > 0) {
        this.isListingLoaded = true
        let uploadFile = this.podDetail[this.selectedRowIndex].selectedCameraPodsToUploadS3
        this.imagearray = []
        let formData = new FormData();
          /*Add the form data we need to submit*/
        for (let key in uploadFile) {
          var binaryData = uploadFile[key]            
              formData.append("file", binaryData);
          }          
          formData.append("awb", this.scanDeliveredAWB);
          let result = await TripServices.UploadCameraBinaryImage(formData)
        if (result.data.code == 200) {
          this.podDetail[this.selectedRowIndex].selectedBrowsedPodsToUploadS3 = []
          this.podDetail[this.selectedRowIndex].selectedScannedPodsToUploadS3 = []
          this.podDetail[this.selectedRowIndex].disabledDeleteImageButton =true
          this.podDetail[this.selectedRowIndex].disableBrowseImageButton = true
          this.podDetail[this.selectedRowIndex].disableCameraImageButton = false
          this.podDetail[this.selectedRowIndex].disableScannerImageButton = true
            this.isListingLoaded = false
          let tempPresignedArray = []
          let tempUploadedImages = []
            result.data.data.map(obj => {
              this.imagearray.push(obj.Location)
              tempUploadedImages.push(obj.Location)
              this.allCapturedPodImagesArray.push(obj.PresignUrl)
              tempPresignedArray .push(obj.PresignUrl) 
            })
            this.uploadHubImageStatus = this.selectedRowIndex
            this.podDetail[this.selectedRowIndex].uploadedPod = tempUploadedImages
            this.podDetail[this.selectedRowIndex].presignHubImage = tempPresignedArray 
            this.$alertify.success("Images uploaded successfully !");
            this.viewCameraImageUploadButton =  false
          this.imageerr = ''
          await this.saveDeliveredSinglePodDetails(this.selectedRowIndex)
          this.isListingLoaded = false
          this.capturePhotoMdlFlag = false

          }
          else{
            this.$alertify.error("Images could not be uploaded.");
            this.isListingLoaded = false
          }
          this.isListingLoaded = false
      }
      else{
        this.isListingLoaded = false
        this.$alertify.error("Please Select Pod Images");
      }
      if (!this.podPayloadToSaveInDb[this.scanDeliveredAWB]) {
        this.podPayloadToSaveInDb[this.scanDeliveredAWB] = { awb:this.scanDeliveredAWB,podQc:this.selectedTableRowDataArray.podqc,badpodreason:this.selectedTableRowDataArray.badpodreason,comments:this.selectedTableRowDataArray.comments,podimages:this.imagearray };
      } else {
        console.log("Key ALready Exits");
      }
      this.isListingLoaded = false
    }, 
   
    onChangePodQcStatus(event, index) {
      if (event) {
          if (event.id == "1")
          {               
              this.enablePodResonDropdown[index] = true
              this.disableClassForPodReason[index] = 'disableAction' 
              this.podDetail[index].badpodreason = []
          } else {
              this.enablePodResonDropdown[index] = false
              this.disableClassForPodReason[index] =''  
          }
      }
  },

    async getTripData(){
      try {
        this.tripData = ''
        this.isBasicInfoLoading = true
        let InputPayload = {
          tripid: this.parentObj.tripId
        };
        let result = await TripServices.getTripData(InputPayload);
        this.tripData = result.data.data.result;
        this.hubsetting = result.data.data.hubsetting;
        this.tmstripid = this.tripData.tmstripid
        this.tripStatus = this.tripData.tripstatus
        this.isListingLoaded = false
        this.isBasicInfoLoading = false
        this.isListingLoaded = false
        this.scantype = this.hubsetting.scantype
        this.palletscanflag = this.hubsetting.ispalletscan
        this.isPalletScanCompulsory = this.palletscanflag == 1 ? true : false
        if(this.scantype == "AWB"){
          this.defaultscanflag = 1
          this.shipmentType = 1
          this.lmShipmentType = 1
        }
        else{
          this.defaultscanflag = 2
          this.shipmentType = 2
          this.lmShipmentType = 2
        }
      } catch (err) {
        console.log(err);
      }
    },

    async getAWBDataForCloseTrip(){
      try {
        this.isListingLoaded = true
        let InputPayload = {
          tripid: this.parentObj.tripId,
          shipmenttype: this.currentTab,
        };
        let result = await TripServices.getAWBDataForCloseTrip(InputPayload);
        if(result.data.code == 200){
          if(this.currentTab == 'firstmile'){
            this.firtmileDocumentData = result.data.data
            this.dwsinscanawbarr = result.data.data
          }else if(this.currentTab == 'lastmile'){
            this.lastmileDocumentData = result.data.data
          }
        }else{
          this.lastmileDocumentData = []
          this.firtmileDocumentData = []
        }
        this.isListingLoaded = false
        this.isBasicInfoLoading = false
        this.isListingLoaded = false
      } catch (err) {
        console.log(err);
      }
    },

    async getMPSDataForCloseTrip(){
      this.isListingLoaded = true
      let InputPayload = {
        tripid: this.parentObj.tripId,
        shipmenttype: this.currentTab,
      };
      let result = await TripServices.getMPSDataForCloseTrip(InputPayload);
      if(result.data.code == 200){
        if(this.currentTab == 'firstmile'){
          this.firstmileMPSData = result.data.data
          let temparr = []
          for(let i=0;i<this.firstmileMPSData.length;i++){
            if(this.firstmileMPSData[i].total_mps.length > 100){
              temparr= []
              for(let j =0;j<100;j++){
                temparr.push(this.firstmileMPSData[i].total_mps[j])  
              } 
            }
            else{
              temparr = this.firstmileMPSData[i].total_mps
            }
            this.firstmileMPSData[i].mpsslot = this.firstmileMPSData[i].total_mps
              this.firstmileMPSData[i].total_mps = temparr.join(",")
          } 
        }else if(this.currentTab == 'lastmile'){
          this.lastmileMPSData = result.data.data
          let lmtemparr = []
          for(let i=0;i<this.lastmileMPSData.length;i++){
            if(this.lastmileMPSData[i].total_mps.length > 100){
              lmtemparr = []
              for(let j =0;j<100;j++){
                lmtemparr.push(this.lastmileMPSData[i].total_mps[j])  
              } 
            }
            else{
              lmtemparr = this.lastmileMPSData[i].total_mps
            }
            this.lastmileMPSData[i].mpsslot = this.lastmileMPSData[i].total_mps
              this.lastmileMPSData[i].total_mps = lmtemparr.join(",")
          } 
        }
      }else{
        this.firstmileMPSData = []
        this.lastmileMPSData = []
      }
      this.isListingLoaded = false
      this.isBasicInfoLoading = false
      this.isListingLoaded = false
    },

    async getToBeScannedCountForMPS(){
      this.isListingLoaded = true
      let InputPayload = {
        tripid: this.parentObj.tripId,
        shipmenttype: this.currentTab,
      };
      let result = await TripServices.getToBeScannedCountForMPS(InputPayload);
      if(result.data.code == 200){
        if(this.currentTab == 'firstmile'){
          this.documentCountFM = result.data.data.documentcount
          this.mpsCountFM = result.data.data.mpscount
          this.tobescanmpsarr = result.data.data.mpsdata
        }else if(this.currentTab == 'lastmile'){
          this.documentCountLM = result.data.data.documentcount
          this.mpsCountLM = result.data.data.mpscount        }
      }
      this.isListingLoaded = false
    },

    async getToBeScannedCountForAWB(){
      this.isListingLoaded = true
      let InputPayload = {
        tripid: this.parentObj.tripId,
        shipmenttype: this.currentTab,
      };
      let result = await TripServices.getToBeScannedCountForAWB(InputPayload);
      if(result.data.code == 200){
        if(this.currentTab == 'firstmile'){
          this.awbToBeScannedFM = result.data.data.documenttobescanned
          this.awbScannedFM = result.data.data.documentscanned
          this.tobescanawbarr = result.data.data.awbdata
        }else if(this.currentTab == 'lastmile'){
          this.awbToBeScannedLM = result.data.data.documenttobescanned
          this.awbScannedLM = result.data.data.documentscanned
        }
      }else{
        this.awbToBeScannedFM = 0
        this.awbToBeScannedLM = 0
        this.awbScannedFM = 0
        this.awbScannedLM = 0
      }
      this.isListingLoaded = false
    },
    onSelectBadRemark(event, index, val) {
      this.currentSelectedRemarkDetails = {}
      this.currentSelectedRemark = ''
      this.badRemarkShippingId = val.awb
      
      this.currentSelectedRemarkDetails = {
          event,
          index
      }
      this.currentSelectedRemark = event.label
      let remarkText = event.id
      this.badPodComment = ''
      if (remarkText && (remarkText == 13 || remarkText == 11 || remarkText == 4)) {
        this.selectedRowIndex = index
        this.viewpodCommentModal = true      
      }
    },
      async getBadPODReason() {
      this.reasonlist = []
      //  let result = await TripServices.getBadPODReason();
      let result = await TripServices.getBadPODReasonFromPodDashbaord();
      if (result.data.code == 200) {
        this.podRemarkArray = result.data.data.data.data
        result.data.data.data.data.map(obj => {
          this.reasonlist.push({
            id: obj.id,
            label: obj.remark,
            imagerequired: 1
          })
        })
      }
    },

    linkClass(idx) {
      if (this.tabIndex === idx) {
        return ['bg-primary', 'text-blue']
      } else {
        return ['bg-light', 'text-info']
      }
    },
    expandAll(){
      this.expanded = true;
      if (this.subtabdisabledflag) {
        this.accordianTab[3] = true;
      } else {
        for (var key in this.accordianTab) {
          this.accordianTab[key] = true;
        }
      }
    },

    collapseAll(){
      this.expanded = false;
      for (var key in this.accordianTab) {
        this.accordianTab[key] = false;
      }
    },
    async GetFTCAwbForclosetrip(){
      this.isListingLoaded = true
      let input = {
        tripid: this.parentObj.tripId,
        type: this.currentTab
      } 
      let result = await TripServices.GetFTCAwbForclosetrip(input);
      if(result.data.code == 200){
        this.selectedAWB = result.data.data.rows.map((el)=>{
          return {
            'AWB':el.awb,
            'Cash':el.ftccashpayment,
            'istdsapplicable' : el.istdsapplicable ? 'TDS Applicable' : '-',
            "collectibleData" : {
              filename:(el.ftcsignedcashmemo)?el.ftcsignedcashmemo.substring(el.ftcsignedcashmemo.lastIndexOf('.')+1).toLowerCase():"",
              filepath:{Location:(el.ftcsignedcashmemo)?el.ftcsignedcashmemo:""}
            }
          }
        }) 
        this.cashcollection = result.data.data.totalcashintrip
        this.cashcollected = result.data.data.ftccashcollectedsrhub
        let ftccashcollectedsrhub = result.data.data.ftccashcollectedsrhub
        if(ftccashcollectedsrhub!=null){
          this.disableflag = true
        }
        else{
          this.disableflag=false
        }
      }
      else{
        this.selectedAWB = []
        this.disableflag = true
      }
      this.isListingLoaded = false 
      // this.isBasicInfoLoading = false
      // this.isListingLoaded = false
    },
    async SaveCollectibles(){
      this.isListingLoaded = true
      let input = {
        tripid:this.parentObj.tripId,
        cashcollected:Number(this.cashcollected)
      }
      let result = await TripServices.SaveCollectibles(input)
      if(result.data.code == 200){
        this.GetFTCAwbForclosetrip()
       this.$alert(`FTC Cash Collected Successfully.`," ","success");
      }
      else {
       this.$alert(result.data.message," ","error");
       this.cashcollected = ''
      }
      this.isListingLoaded = false
     },
     
     async SaveCashMemo(file,awb){
       let input = {
         "lastmodifiedby":this.userName,
         "file":file,
         "awb":awb
       }
       let result = await TripServices.SaveCashMemo(input)
       if(result == 200){
         return true
       }
       else{
         return false
       }
     },
     
    async UploadDocument(event,documentid) {
      this.isListingLoaded = true 
      let filepath = "collectibles";
      let uploadFile = event.target.files[0]
      if(uploadFile.size > 5242880){
        this.isListingLoaded = false 
        return this.$alert(`Please Upload Document Less Than 5MB.`,"Collectible","error");
      }
      if (uploadFile.type == "image/jpeg" || uploadFile.type == "image/png" ||uploadFile.type == "image/jpg" ||uploadFile.type == ""){
        let formData = new FormData();
        formData.append("file", uploadFile);
        formData.append(filepath, true);
        formData.append("fileName", uploadFile.name);
        let result = await TripServices.UploadCollectibleDocument(formData);
        this.isListingLoaded = false 
        if(result.data.code == 200){
          if(filepath == 'collectibles'){
            let alertMessage =''
            alertMessage = "Collectible document"
            let collectibledocument = result.data.data;
            let collectibledoc = uploadFile.name.substring(uploadFile.name.lastIndexOf('.')+1).toLowerCase();
            this.selectedAWB[documentid].collectibleData = {
              filename: collectibledoc,
              filepath: collectibledocument
            }
          }
          this.SaveCashMemo(this.selectedAWB[documentid].collectibleData.filepath.Location,this.selectedAWB[documentid].AWB)
          this.$alert(`Document Upload successfully.`,"Collectible","success");
        }
        else 
        {
            event.target.value = '';
            this.isListingLoaded = false 
            this.$alert("Document Upload Failed.","Collectibles","error");
        }
      }else {
        event.target.value = '';
        this.isListingLoaded = false 
        this.$alert("please upload only Allowed file format","GST Document","error");
        return true;
        }
      },
      
      openCollectibleImage(image) {
        this.Loading = true;
        this.imageLoader =true
        var modal = document.getElementById('myModalImg' + image);
        var img = document.getElementById('imgid' + image);
        var modalImg = document.getElementById("img" + image);
        var captionText = document.getElementById("captionImg" + image);
        modal.style.display = "block";
        modalImg.src = image;
        this.imageLoader =false
      },
      
      setname(id, name){
        return name+id;
      },
      changeTab(tab){
        this.currentTab = tab
        this.awbToBeScannedFM = 0
        this.awbToBeScannedLM = 0
        this.awbScannedFM = 0
        this.awbScannedLM = 0
        this.totalInvoice = ''
        this.getAWBDataForCloseTrip()
        this.getToBeScannedCountForAWB()
        this.getMPSDataForCloseTrip()
        this.getToBeScannedCountForMPS()
        this.getPODDetailAgainstTrip()
        this.GetFTCAwbForclosetrip()
      },

      async validateAWB(){
        try {
          if((this.currentTab=='firstmile' && this.scanAWB.length >= this.AWBLengthLimit) || (this.currentTab=='lastmile' && this.scanUndeliveredAWB.length >= this.AWBLengthLimit)){
            this.totalInvoice = ''
            this.awbErr = ''
            this.undeliveredAWBErr = ''
            let input = {
              tripid: this.parentObj.tripId,
              shipmenttype: this.currentTab,
              awb: this.currentTab=='firstmile'?this.scanAWB:this.scanUndeliveredAWB
            }
            this.isAWBScanning = true;
            let result = await TripServices.ValidateAWB(input);
            if(result.data.code == 200){
              this.totalInvoice = Number(result.data.data.totalinvoice)
              this.awbErr = ''
              this.undeliveredAWBErr = '';
            }else{
              if(this.currentTab == 'firstmile'){
                this.awbErr = result.data.message
              }else{
                this.undeliveredAWBErr = result.data.message
              }
            }
            this.isAWBScanning = false;
          }
        } catch (err) {
          console.log(err);
          this.isAWBScanning = false;
        }
      },

    validatePhysicalInvoice(){
      if(this.currentTab == 'firstmile'){
        if(Number(this.physicalInvoices) > Number(this.totalInvoice)){
          this.physicalInvoiceErr = 'Physical Invoice should be less than or equal to Total Invoice'
        }else{
          this.physicalInvoiceErr = ''
        }
      }else{
        if(Number(this.lmPhysicalInvoices) > Number(this.totalInvoice)){
          this.lmPhysicalInvoiceErr = 'Physical Invoice should be less than or equal to Total Invoice'
        }else{
          this.lmPhysicalInvoiceErr = ''
        }
      }
    },

    async scanAWBForClose() {
      if(this.checkErr()){
        return false
      }
      this.isAWBScanning = true
      let input = {
        tripid: this.parentObj.tripId,
        type: this.currentTab,
        awb: this.currentTab=='firstmile'?this.scanAWB:this.scanUndeliveredAWB,
        scanstage: 'CloseScan',
        physicalinvoice: this.currentTab=='firstmile'?Number(this.physicalInvoices):Number(this.lmPhysicalInvoices),
		hubid:this.defaultHubID
      }
      let result = await TripServices.scanAWB(input)
      if(result.data.code == 200){
		if(result.data.data[1][0].allocationtype=='firstmile'){
			let message = `<div style="text-align:left">
			<p>${result.data.message}</p>
			<p>Destination: ${result.data.data[1][0].fmsort.destinationhub?result.data.data[1][0].fmsort.destinationhub:""}</p>
			<p>Zone: ${result.data.data[1][0].fmsort.zone?result.data.data[1][0].fmsort.zone:""}</p>
			<p>Primary Sector: ${result.data.data[1][0].fmsort.primarysector?result.data.data[1][0].fmsort.primarysector:""}</p>
			<p>Secondary Sector: ${result.data.data[1][0].fmsort.secondarysector?result.data.data[1][0].fmsort.secondarysector:""}</p>
			</div>`
			var msg = this.$alertify.success(message);
			msg.dismissOthers();
			msg.delay(0);
			this.alertmsg = msg;
		}else{
			this.$alertify.success(result.data.message);
		}
      } else{
        msg = this.$alertify.error(result.data.message);
		msg.dismissOthers();
      }
      this.isAWBScanning = false
      this.getAWBDataForCloseTrip()
      this.getToBeScannedCountForAWB()
    },

    checkErr(){
      let err = 0
      if(this.currentTab == 'firstmile'){
        if(this.scanAWB.length >= this.AWBLengthLimit  && !this.awbErr){
          this.awbErr = ''
        }else{
          err = 1
          this.awbErr = 'Please Input AWB'
        }
        if(Number(this.physicalInvoices) > 0 && Number(this.totalInvoice) >= Number(this.physicalInvoices)){
          this.physicalInvoiceErr = ''
        }else{
          err = 1
          this.physicalInvoiceErr = 'Physical Invoice should be less than or equal to Total Invoice'
        }
      }else{
        if(this.scanUndeliveredAWB.length >= this.AWBLengthLimit  && !this.undeliveredAWBErr){
          this.undeliveredAWBErr = ''
        }else{
          err = 1
          this.undeliveredAWBErr = 'Please Input AWB'
        }
        if(Number(this.lmPhysicalInvoices) > 0 && Number(this.totalInvoice) >= Number(this.lmPhysicalInvoices)){
          this.lmPhysicalInvoiceErr = ''
        }
        else {
          err = 1
          this.lmPhysicalInvoiceErr = 'Please Input Physical Invoices'
        }
      }
      return err
    },

    async scanMPSForClose() {
      try {
        if((this.currentTab=='firstmile' && this.scanMPS.length >= this.MPSLengthLimit) || (this.currentTab=='lastmile' && this.scanUndeliveredMPS.length >= this.MPSLengthLimit)){
          if((this.currentTab=='firstmile' && this.isFMPalletScan) || (this.currentTab=='lastmile')){
            this.isMPSScanning = true
            let input = {
              tripid: this.parentObj.tripId,
              type: this.currentTab,
              scanstage: 'CloseScan',
              lastmodifiedby:this.userName,
              hubid:this.defaultHubID
            }
            if(this.currentTab == 'firstmile'){
              if(this.shipmentType == 1){
                this.tobescanawbarr.forEach(el=>{
                  if(el.awb == this.scanMPS){
                    input.routemode = el.routemode
                  }
                })
                input.awb = this.scanMPS
              }else if(this.shipmentType == 2){
                this.tobescanmpsarr.forEach(el=>{
                  if(el.mps == this.scanMPS){
                    input.routemode = el.routemode
                    input.awb = el.awb
                  }
                })
                input.mps = this.scanMPS
                input.awb = ''
              }else{
                this.isMPSScanning = false
                return false
              }
            }else{
              if(this.lmShipmentType == 1){
                input.awb = this.scanUndeliveredMPS
              }else if(this.lmShipmentType == 2){
                input.mps = this.scanUndeliveredMPS
                input.awb = ''
              }else{
                this.isMPSScanning = false
                return false
              }
            }
            let result = await TripServices.scanMPS(input)
            if(result.data.code == 200){
              if (this.shipmentType == 1) {
                this.lastMpsAwbScannedData = { awb: result.data.data[1][0].awb, mps: '', destinationhubname: result.data.data[1][0].destinationhubname,scannedMPS: result.data.data[1][0].scannedMPS,totalAWB: result.data.data[1][0].totalAWB }
              } else if (this.shipmentType == 2) {
                this.lastMpsAwbScannedData = { awb: result.data.data[1][0].awb, mps: result.data.data[1][0].mps, destinationhubname: result.data.data[1][0].destinationhubname,scannedMPS: result.data.data[1][0].scannedMPS,totalAWB: result.data.data[1][0].totalAWB }
              }
              this.scanMPS = ''
              this.scanUndeliveredMPS = ''
              // this.shipmentType = ''
              // this.lmShipmentType = ''
              let rtowarning = 0
              if(result.data.data[1][0].scandetails && result.data.data[1][0].scandetails.length >= 0){
                for (var i = 0; i < result.data.data[1][0].scandetails.length; i++) {
                  if(result.data.data[1][0].scandetails[i].data.ReturnCode != 101 && !result.data.data[1][0].scandetails[i].data.rto){
                    rtowarning = 0;
                    break;
                  }
                  else{
                    rtowarning = 1
                  }
                }
                if(rtowarning == 1){
                  this.$alertify.warning('Shipment is in RTO Terminal');
                }
              }
              // this.shipmentType = ''
              // this.lmShipmentType = ''
			  if(result.data.data[1][0].allocationtype=='firstmile'){
				let message = `<div style="text-align:left">
				<p>${result.data.message}</p>
				<p>Destination: ${result.data.data[1][0].fmsort.destinationhub?result.data.data[1][0].fmsort.destinationhub:""}</p>
				<p>Zone: ${result.data.data[1][0].fmsort.zone?result.data.data[1][0].fmsort.zone:""}</p>
				<p>Primary Sector: ${result.data.data[1][0].fmsort.primarysector?result.data.data[1][0].fmsort.primarysector:""}</p>
				<p>Secondary Sector: ${result.data.data[1][0].fmsort.secondarysector?result.data.data[1][0].fmsort.secondarysector:""}</p>
				</div>`
				var msg = this.$alertify.success(message);
				msg.dismissOthers();
				msg.delay(0);
				this.alertmsg = msg;
				
			  }else{
				this.$alertify.success(result.data.message);
			  }
              if(this.isPalletScanCompulsory){
                if(this.currentTab == 'firstmile'){
                  this.isFMPalletScan = false
                }
              }
            } else{
              msg = this.$alertify.error(result.data.message)
			  msg.dismissOthers();
            }
            this.isMPSScanning = false
            this.getMPSDataForCloseTrip()
            this.getToBeScannedCountForMPS()
          }else{
            this.$alert("Pallet is not scanned", "", "error");
          }
        }
      } catch (error) {
        this.isMPSScanning = false
        this.$alertify.error("Internal Server Error.")
      }
    },
    async DWSManualCheck(data) {
      try {
        this.isAWBScanning = true
        // class Queue {
        //   constructor() {
        //     this.elements = {};
        //     this.head = 0;
        //     this.tail = 0;
        //     this.container = []
        //   }
        //   enqueue(element) {
        //     this.container.push(element)
        //     this.tail++;
        //   }
        //   enqueueArray(array) {
        //     for (let i = 0; i < array.length; i++) {
        //       this.enqueue(array[i].awb);
        //     }
        //   }
        //   peek(){
        //     return this.container;
        //   }
        //  async createbatch(num,tripid){
        //     while(this.container.length!=0){
        //       var awb =[]
        //       let limit = this.container.length > num ? num : this.container.length 
        //       for(let i =0;i<limit;i++) {
        //         this.tail--
        //         const el = this.container[i]
        //         if(el!=undefined) {
        //           awb.push(el)
        //         }
        //         const index = this.container.indexOf(el);
        //         this.container = this.container.filter((value, i) => i !== index);
        //       }
        //       if(awb.length!=0) {
        //         let InputPayload = {
        //           tripid : tripid,
        //           awb : awb
        //         }
        //         await TripServices.CheckDWSInscanbutton(InputPayload)
        //       }
        //     }
        //     return {valid : 1}
        //   }
        //   get length() {
        //     return this.tail - this.head;
        //   }
        // }
        // const dwsqueue = new Queue()
        // dwsqueue.enqueueArray(this.dwsinscanawbarr)
        // this.Loader = true
        // let result = await dwsqueue.createbatch(5,this.parentObj.tripId)
        let tripid = this.parentObj.tripId
        let InputPayload = {
          tripid: tripid,
          awb : [data.awb]
        }
         await TripServices.CheckDWSInscanbutton(InputPayload)
        this.isAWBScanning = false
        // if(result.valid){
          this.isMPSScanning = true
          await this.getMPSDataForCloseTrip()
          this.isMPSScanning = false
        // }
        // this.Loader = false
      } catch (error) {
        this.isAWBScanning = false
        this.isMPSScanning = false
        this.$alertify.error("Internal Server Error.")
      }
    },

    async scanPallet(){
      if(this.isPalletScanCompulsory){
        if((this.currentTab=='firstmile' && !this.ScanPalletFM) || this.currentTab=='lastmile' && !this.ScanPalletLM){
          if(this.currentTab=='firstmile'){
            this.fmScanPalletErr = 'Please scan pallet'
          }else{
            this.lmScanPalletErr = 'Please scan pallet'
          }
          return false
        }
        this.isMPSScanning = true
        let input = {
          tripid: this.parentObj.tripId,
          type: this.currentTab,
          scanstage: 'CloseScan',
          scantype:this.scantype,
          pallet: this.currentTab=='firstmile'?this.ScanPalletFM : this.ScanPalletLM
        }
        if(this.scantype == "AWB"){
          input.shippingid = this.lastMpsAwbScannedData.awb
        }
        if(this.scantype == "MPS"){
          input.shippingid = this.lastMpsAwbScannedData.mps
        }
        let result = await TripServices.scanPallet(input)
        if(result.data.code == 200){
          this.$alertify.success(result.data.message);
          if(this.currentTab == 'firstmile'){
            this.ScanPalletFM = ''
            this.isFMPalletScan = true
          }else{
            this.ScanPalletLM = ''
            this.isLMPalletScan = true
          }
          this.lastMpsAwbScannedData = ''
          this.getMPSDataForCloseTrip()
        }else{
          this.$alertify.error(result.data.message);
        }
        this.isMPSScanning = false
      }else{
        this.$alert("Pallet Scan Not Allowed", "", "error");
      }
    },



    SubExpandAll(){
      this.subexpanded = true;
      for (var key in this.accordianTab) {
        this.subaccordianTab[key] = true;
      }
    },
    SubCollapseAll(){
      this.subexpanded = false;
      for (var key in this.accordianTab) {
        this.subaccordianTab[key] = false;
      }
    },

    toggleCheck(tabid){
      this.expanded = false;
      for (var key in this.accordianTab) {
        if(tabid != key){
          this.subaccordianTab[key] = false;
        }
      }
    },
    SubtoggleCheck(tabid){
      this.subexpanded = false;
      for (var key in this.accordianTab) {
        if(tabid != key){
          this.accordianTab[key] = false;
        }
      }
    },
    showCloseTrip(){
        this.$emit("goBackToParent")
    },
    closeDepartTrip(){
      this.showDepartTrip = false;
    },
    getCustomTableEvent(){

    },
    showDepsCloseTrip(tab){
      this.closeTripData = {
        tripstatus: this.tripStatus,
        username: this.tripData.username,
        vehiclenumber: this.tripData.vehiclenumber,
        tripId: this.parentObj.tripId,
        tmstripid: this.tmstripid,
        actionType: this.parentObj.actionType,
        currenttab: tab
      }
      this.depscloseTrip = true;
    },
    callParent(){
      this.depscloseTrip = false;
    },
    disabledPodQc(data) {
      if (data.documentscanned != 3) {
        if (data.uploadedPod.length ==0) {
          return false
        } else {
          return false
        }        
      } else {
       return true
      }
    },
    disabledBadPodReason(data, index) {
      if (this.enablePodResonDropdown[index] || data.documentscanned == 3 || data.isdeliverywopod == 1) {
        if (data.podqc == 2) {
          return false
        } else {
          return true
        }   
      } else {
        return false
      }
    }, 
    validatepodQc(data) {
      if (data.isdeliverywopod == 1 && data.uploadedPod ==0) {
        return ''
      } else {
        return 'required'
      }
    },
    validateBadPodReason(data) {
      if (data.podqc == 2) {
        return 'required'
      } else {
        return ''
      }
    },
    CloseTripConfirmation(){
      this.$confirm("This action cannot be undone. Please confirm trip close.","","question").then(() => {
        this.closeTrip()
      }).catch((err)=>{
       console.log(err)
      });

    },
    async getPODDetailAgainstAWB(){
      if(this.scanDeliveredAWB.length >= this.AWBLengthLimit){
        // this.podDetail = []
        this.podImage = ''
        let input = {
          tripid: this.parentObj.tripId,
          shipmenttype: this.currentTab,
          awb: this.scanDeliveredAWB
        }
        let result = await TripServices.getPODDetailAgainstAWB(input);
        if(result.data.code == 200){
          // this.podDetail[0] = result.data.data

            this.scanDeliveredAWBErr = ''
          this.podImage = result.data.data.podurl.destinationpodimg[0]
          if(result.data.data.documentscanned != 0){
            this.podalreadyuploadErr = 'POD already uploaded'
          }else{
            this.podalreadyuploadErr = ''
          }
        }else{
          this.scanDeliveredAWBErr = 'AWB Not Found'
          this.podalreadyuploadErr = ''
        }
      }
    },
    async getPODDetailAgainstTrip() {
      this.podDetail = []
      let tempArray = []
      this.toalDeliveredPod = 0
      this.totalScannedAwb = 0
      this.remainingAwb = 0
        this.podImage = ''
        let input = {
          tripid: this.parentObj.tripId,
          shipmenttype: this.currentTab,
          // awb: this.scanDeliveredAWB
        }      
      let result = await TripServices.getPODDetailAgainstTrip(input);
        if(result.data.code == 200){
          let podData = result.data.data
          // this.toalDeliveredPod = podData.length
          for (let i = 0; i < podData.length; i++) {            
            const element = podData[i];
            let uploadedHubImage = []
            if (element.podurl.podimages && element.documentscanned == 3) {
              // this.totalScannedAwb = this.totalScannedAwb + 1
              for (const key in element.podurl.podimages) {
                if (Object.hasOwnProperty.call(element.podurl.podimages, key)) {
                  uploadedHubImage.push(element.podurl.podimages[key]);                  
                }
              }
            }
            let obj = {
              "awb" : element.awb,
              "podqc": element.podqc ? element.podqc == 'good' ? 1 : 2 : null,
              "badpodreason": element.badpodreason ? element.badpodreason.split(',') : null,
              "comments": element.podcomments ? element.podcomments : 'NA',
              "shipmenttag":element.isdeliverywopod == 1 ? 'W/O POD'  : 'NA',
              "reviewstatus": 'false',
              "podurl": element.podurl,
              "uploadedPod": [],
              "selectedBrowsedPodsToUploadS3": [],
              "selectedBrowsedPodsToUploadS3Save": [],
              "selectedScannedPodsToUploadS3": [],
              "selectedCameraPodsToUploadS3":[],
              "error": false,
              "presignHubImage": [],
              "uploadedHubImage":uploadedHubImage,
              "documentscanned": element.documentscanned,
              "disableBrowseImageButton" : false,
              "disableCameraImageButton" : false,
              "disableScannerImageButton": false,
              "disabledDeleteImageButton": false,
              "isdeliverywopod": element.isdeliverywopod || 0,
              "isreuploadrequired": element.isreuploadrequired || 0,
              "additionaldocuments": element.additionaldocuments              
            }
            tempArray.push(obj)
            
          }
          tempArray.sort((a, b) => a.documentscanned - b.documentscanned)
          this.podDetail= tempArray
          this.scanDeliveredAWBErr = ''
        }else{
          this.scanDeliveredAWBErr = ''
        }
    },

    fileview(index){
      var link = document.createElement('a');
      link.href = index;
      link.setAttribute('target','_blank');
      window.open(index, '_blank');
      link.remove();
      return true;
    },

    async handleFileUpload(event) {
      if (this.scanDeliveredAWB) {
        this.isListingLoaded = true
        let uploadFile = event.target.files;
        this.imagearray = []
          let formData = new FormData();
          /*Add the form data we need to submit*/
          for (let key in uploadFile) {
            if(key >= 0 ){
              if(uploadFile[key].type != "image/jpeg" &&
            uploadFile[key].type != "image/jpg" && uploadFile[key].type != "image/png")
            {
              this.$alertify.error("Please upload only valid file format");
              this.isListingLoaded = false
              return false
            }
            }
            if (key == 'length' && uploadFile[key] > 3) {
              this.$alertify.error("Please upload maximum 3 file");
              this.isListingLoaded = false
              return false
            }
            if (uploadFile[key].size > (1024 * 1024 * 3)) {
              this.$alert(`${uploadFile[key].name} size is greater than 3MB`, "", "error");
              this.isListingLoaded = false
              return false
            } else {
              formData.append("file", uploadFile[key]);
            }
          }
          formData.append("awb", this.scanDeliveredAWB);
          let result = await TripServices.UploadPODImage(formData)
          if (result.data.code == 200) {
            result.data.data.map(obj => {
              this.imagearray.push(obj.Location)
            })
            this.$alertify.success("Images uploaded successfully !");
			this.imageerr = ''
          }
          else{
            this.$alertify.error("Images could not be uploaded.");
            this.isListingLoaded = false
          }
          this.isListingLoaded = false
      }
      else{
        this.isListingLoaded = true
        this.$alertify.error("Please scan AWB");
        // this.awbErr = 'Please Scan AWB'
        this.isListingLoaded = false
      }
    },

    openImage() {
      this.imgOpenFlagFunction();	
      // this.$viewerApi({
      //   images: [this.podImage],
      // })
      var modal = document.getElementById('myModalImg' + this.podImage);
      var img = document.getElementById('imgid' + this.podImage);
      var modalImg = document.getElementById("img" + this.podImage);
      var captionText = document.getElementById("captionImg" + this.podImage);
      modal.style.display = "block";
      modalImg.src = this.podImage;
	  this.viewpod = true
	  this.viewpodErr = ''
      // captionText.innerHTML = this.podImage;
    },
	imgOpenFlagFunction(){
	  if(this.saveDetailsFlag == true){
		this.imgOpenFlag=false;
	  }else{
		this.imgOpenFlag=true;  
	  }
	},
    closemodal(id) {
      this.Loading =false
      var modal = document.getElementById(id);
      modal.style.display = "none";
    },

    selectPODReason(event,index, val){
      this.reasonSearch = reason.id
	    this.badReason = reason.label
      this.imageRequired = reason.imagerequired
    },

	selectPODQC(event){
		let value = event.target.value
		if(value == 'good'){
		  this.imageRequired = 0;
		  this.selectedBadRemarks = null
		  this.reasonErr = ''
		  this.imageerr = ''
		}
		this.podQCErr = ''
	},

    async savePODDetail(selectedRemark){	
	  let podBadRemark = []	
	  if(selectedRemark){
		for (let k = 0; k < selectedRemark.length; k++) {
		  const element = selectedRemark[k]; 
		  let badRemark = this.podRemarkArray.find(value => value.id == element)                        
		  if (badRemark) {
			podBadRemark.push(badRemark.remark)
		  }                                                       
		}
	  }
      if(this.checkErrForPOD()){
        return false
      }
	  this.saveDetailsFlag=true;
      this.imgOpenFlagFunction();
      this.isListingLoaded = true
      let input = {
        "tripid":this.parentObj.tripId,
        "parentawb":this.scanDeliveredAWB,
        "allocationtype":this.currentTab=='lastmile'?"LM":"FM",
        "podquality":this.PODQC,
        "comments":this.Comments
      }
      if(this.PODQC == 'bad'){
        input.badpodreason= podBadRemark.toString()
        input.podimages= this.imagearray
      }
      else
      input.podimages= this.imagearray
      let result = await TripServices.savePOD(input);
      if(result.data.code == 200){
        this.$alertify.success(result.data.message);
        this.clearData()
        this.getPODDetailAgainstTrip()
        this.toggleCheck(2);
        this.accordianTab[2] = true
        // this.accordianTab[1] = false;
        // this.subaccordianTab[1]=true;
      }else{
        this.$alertify.error(result.data.message);
      }
      this.isListingLoaded = false
	  this.viewpod = false
	  this.clearData()
	  this.saveDetailsFlag=false;
    },
    checkBadReasonField(index) {
      if(this.selectedPodQc[index] || this.selectedBadRemarks[index]){
        this.selectedBadRemarks[index].error = true
      }else{
        this.selectedBadRemarks[index].error = false
      }
    },
   async saveDeliveredSinglePodDetails(index) {
      // this.$validator.validateAll("deliveredPodForm").then((result) => {
      //   if (result) {
          const element = this.podDetail[index];
          if (element.documentscanned != 3) {
            if (element.isdeliverywopod !=1) {
                if (element.uploadedPod && element.uploadedPod.length <= 0 || element.reviewstatus == "false" || element.documentscanned == 3) {
                  let destinationImages = element.podurl.destinationpodimg ? element.podurl.destinationpodimg : []
                  let validatedPodArray = destinationImages.filter(Boolean);
                  if (validatedPodArray.length != 0) {
                    this.podDetail[index].error = true
                    this.notReviewedHubImageShipmentArray.push({
                      awb: element.awb,
                      viewFieldImage: element.reviewstatus == "false" ? "Pending" : "Reviewed",
                      uploadedHubImage: element.uploadedPod.length > 0 ? 'Uploaded' : "Not Uploaded"
                    })
                  } else {
                    this.podDetail[index].error = false
                  }              
                } else {
                  this.podDetail[index].error = false
                }
            } else {
              this.podDetail[index].error = false
            }
          } else {
            this.podDetail[index].error = false
          } 
          this.disabledSaveDeliveredPodBtn = this.isPodSubmitDisabled 
          if (!this.isPodSubmitDisabled ) {
            // Your logic to submit the form   
            let saveResult = await this.saveSinglePODDetail(index)
            if (saveResult.code == 200) {
              this.$alertify.success(saveResult.message)
              return true
            } else {
              this.$alertify.error(saveResult.message)
              return false
            }
          } else {
            this.disabledLmCloseTrip = true
            this.$alert("For a successful submission, please ensure you've reviewed the field image and uploaded the hub image.",'', "error");
          }
        // } else {
        //   return true
        // }
      // }).catch((err) => {
      //   console.log('errors exist',err);
      //   return false;
      // });
    },
    async saveSinglePODDetail(index) {
      const shipmentData = this.podDetail[index];
      if (shipmentData.uploadedPod.length != 0) {
        this.isListingLoaded = true
        let input = {
          "tripid": this.parentObj.tripId,
          "parentawb": shipmentData.awb,
          "allocationtype": this.currentTab == 'lastmile' ? "LM" : "FM",
          "podquality": shipmentData.podqc == 1 ? 'good' : 'bad',
          "comments": shipmentData.comments ? shipmentData.comments : 'NA'
        }
        if (shipmentData.podqc == 2) {
          input.badpodreason = shipmentData.badpodreason.toString()
          input.podimages = shipmentData.uploadedPod
        }
        else
          input.podimages = shipmentData.uploadedPod
        let result = await TripServices.savePOD(input); 
        if (result) {
          this.viewpod = false
          this.saveDetailsFlag = false;
          // this.clearData()
          this.getPODDetailAgainstTrip()
          // this.toggleCheck(2);
          // this.accordianTab[2] = true
          // this.accordianTab[1] = false;
          // this.subaccordianTab[1] = true;
          // this.disabledLmCloseTrip = false
          this.isListingLoaded = false
          return ({ code: 200, message: "Record Save Successfully" })
          
        } else {
          this.isListingLoaded = false
          return({code:201,message:"Something Went Wrong"})
        }
       
      } else {
        // this.$alertify.success("Please Select Hub Image");
        this.isListingLoaded = false
        return({code:201,message:"Please Select Hub Image"})
       
      }
      
      // if (this.podPayloadToSaveInDb) {
      //   for (const key in this.podPayloadToSaveInDb) {
      //     if (Object.hasOwnProperty.call(this.podPayloadToSaveInDb, key)) {
      //       this.isListingLoaded = false
      //     }
      //   }
        
      // } else {
      //   this.isListingLoaded = false
      //   this.$alertify.error("Please Select Hub Image")
      // }

    },
  
    saveDeliveredPodDetails() {
      this.$validator.validateAll("deliveredPodForm").then((result) => {
        if (result) {
          for (let i = 0; i < this.podDetail.length; i++) {
            const element = this.podDetail[i];
            if (element.documentscanned != 3) {
              if (element.isdeliverywopod !=1) {
                  if (element.uploadedPod && element.uploadedPod.length <= 0 || element.reviewstatus == "false" || element.documentscanned == 3) {
                    let destinationImages = element.podurl.destinationpodimg ? element.podurl.destinationpodimg : []
                    let validatedPodArray = destinationImages.filter(Boolean);
                    if (validatedPodArray.length != 0) {
                      this.podDetail[i].error = true
                      this.notReviewedHubImageShipmentArray.push({
                        awb: element.awb,
                        viewFieldImage: element.reviewstatus == "false" ? "Pending" : "Reviewed",
                        uploadedHubImage: element.uploadedPod.length > 0 ? 'Uploaded' : "Not Uploaded"
                      })
                    } else {
                      this.podDetail[i].error = false
                    }              
                  } else {
                    this.podDetail[i].error = false
                  }
              } else {
                this.podDetail[i].error = false
              }
            } else {
              this.podDetail[i].error = false
            }
          }  
          this.disabledSaveDeliveredPodBtn = this.isPodSubmitDisabled 
          if (!this.isPodSubmitDisabled ) {
            // Your logic to submit the form   
            this.savePODDetail_test()
            console.log('Form submitted successfully');
          } else {
            this.disabledLmCloseTrip = true
            this.$alert("For a successful submission, please ensure you've reviewed the field image and uploaded the hub image.",'', "error");
          }
        } else {
          return true
        }
      }).catch((err) => {
        console.log('errors exist',err);
        return false;
      });
    },
    async savePODDetail_test() {
      for (let i = 0; i < this.podDetail.length; i++) {
        const shipmentData = this.podDetail[i];
        if (shipmentData.uploadedPod.length != 0) {
          this.isListingLoaded = true
          let input = {
            "tripid": this.parentObj.tripId,
            "parentawb": shipmentData.awb,
            "allocationtype": this.currentTab == 'lastmile' ? "LM" : "FM",
            "podquality": shipmentData.podqc == 1 ? 'good' : 'bad',
            "comments": shipmentData.comments ? shipmentData.comments : 'NA'
          }
          if (shipmentData.podqc == 2) {
            input.badpodreason = shipmentData.badpodreason.toString()
            input.podimages = shipmentData.uploadedPod
          }
          else
            input.podimages = shipmentData.uploadedPod
          let result = await TripServices.savePOD(input);        
        }

      }
      this.$alertify.success("Successful");
      if (this.podPayloadToSaveInDb) {
        for (const key in this.podPayloadToSaveInDb) {
          if (Object.hasOwnProperty.call(this.podPayloadToSaveInDb, key)) {
            this.isListingLoaded = false
          }
        }
        this.viewpod = false
        this.saveDetailsFlag = false;
        this.clearData()
        this.getPODDetailAgainstTrip()
        this.toggleCheck(2);
        this.accordianTab[2] = true
        this.accordianTab[1] = false;
        this.subaccordianTab[1] = true;
        this.disabledLmCloseTrip = false
      } else {
        this.isListingLoaded = false
        this.$alertify.error("Please Select Hub Image")
      }

    },
    checkErrForPOD(){
      let err = 0
        if(!this.scanDeliveredAWB || this.scanDeliveredAWBErr){
          this.scanDeliveredAWBErr = 'Please Scan Valid AWB'
          err = 1
        }else{
          this.scanDeliveredAWBErr = ''
		  this.viewpodErr = ''
		  if(!this.viewpod){
			this.viewpodErr = 'Please Click To View POD'
			err = 1
		  }
        }
        if(!this.PODQC){
          this.podQCErr = 'Please Select QC'
          err = 1
        }else{
          this.podQCErr = ''
          if(this.PODQC == 'bad'){
			if(this.selectedBadRemarks){
				if(!this.selectedBadRemarks.length){
				  this.reasonErr = 'Please Select Reason'
				  err = 1	
				}else{
				  this.reasonErr = ''
				}
			}else{
			   this.reasonErr = 'Please Select Reason'
				err = 1
			}
          }else{
			this.reasonErr = ''
		  }
        }	
        if(this.imageRequired == 1 && this.imagearray.length == 0){		  
          err = 1
          this.imageerr = "Please Select Image"
        }
        else if(this.imagearray.length > 6){
          err = 1
          this.imageerr = 'Maximum 6 images allowed'
        }
        else{
          this.imageerr = ''
        }
      return err
      },

    clearData(){
      this.scanDeliveredAWB = ''
      this.PODQC = ''
      this.reasonSearch = null
      this.imageRequired = 0
      this.Comments = ''
      this.podImage = ''
      this.imagearray = []
	  this.badReason = ''
	  this.selectedBadRemarks = null
    },

    async closeTrip() {
      if(this.tripData.vehicletype == 'market'){
        this.VehicleCloseODOreading = this.VehicleCloseODOreading ? this.VehicleCloseODOreading : 1
        this.ODOhidden = true;
    }else{
      if(!this.VehicleCloseODOreading){
        this.ODOErr = 'Please enter ODO reading(km)'
        this.ODOhidden = false;
        return false
      }
    }
      this.Loader = true
      // let inputpayload = {
      //   tripid: this.parentOBJ.tripID,
      // }
      // let check = await TripServices.checkAllDocumentScanned(inputpayload);
      // if(check.data.code != 200){
      //   this.$alert(result.data.message, "", "error");
      //   this.Loader = false
      //   return false
      // }
      this.ODOErr = ''
      let input = {
        tripid: this.tripData.id,
        sruserid : this.tripData.userid,
        hubid: this.tripData.hubid,
        closekm: Number(this.VehicleCloseODOreading),
        tripstate: 'closed',
        vehicleno: this.tripData.vehiclenumber,
        vehicletype: this.tripData.vehicletype,
        tmstripid : this.tripData.tmstripid,
        operationType:"cargo",
        lastmodifiedby:this.userName,
      }
      if(this.tripData.vehicletype == 'vehicle'){
        let vehiclelist = await this.getContractedVehicleList(this.tripData.hubid)
        var vendorvehicleid
        for (let i = 0; i < vehiclelist.length; i++) {
          if(vehiclelist[i].VehicleNumber == this.tripData.vehiclenumber){
            vendorvehicleid = vehiclelist[i].VendorVehicleId
            break;
          }
        }
        input.vehiclevendorid = vendorvehicleid
      }
      let result = await TripServices.closeTrip(input);
      if(result.data.code == 200){
        this.tripStatus = 'closed'
        this.$alert("Trip Closed Successfully", "", "success");
        this.getTraceIP(input);
      }else if(result.data.code == 409){
        this.ODOhidden=false
        this.showCloseTripModal = true
        let podarr = []
        this.AWBArr = []
        this.FTCAWB = []
        this.FTCCashmemo = []
        this.pendingInvoice=[]
        result.data.data.forEach(el=>{
          if(el.awb && !el.mps && !el.ftccashpayment){
            let awbdetails = {
              awb: el.awb,
              allocationtype:el.allocationtype == 'firstmile' ? 'First Mile' : 'Last Mile',
            }
            if(el.awbstatus == 'picked'|| el.awbstatus == 'shipped'){
              awbdetails.process = 'Document Inscan'
            }else if(el.awbstatus == 'delivered'){
              awbdetails.process = 'POD Process'
            }else if(el.awbstatus == 'undelivered'){
              awbdetails.process = 'Undelivered Document Inscan'
            }
            this.AWBArr.push(awbdetails)
          }else if(el.mps){
            let mpsdetails 
            mpsdetails = {
              awb: el.awb,
              allocationtype:el.allocationtype == 'firstmile' ? 'First Mile' : 'Last Mile'
            }
            if(el.mpsstatus == 'picked'){
              mpsdetails.process = 'MPS Inscan'
            }
            else if (el.unsyncedflag==1){
              mpsdetails.process = 'Inscan Failed !! Please try again'
            }
            else if(el.mpsstatus == 'delivered'){
              mpsdetails.process = 'No Process'
            }else if(el.mpsstatus == 'undelivered'){
              mpsdetails.process = 'Undelivered MPS Inscan'
            }
            podarr.push(mpsdetails)
          }
         
          if(el.cash){
            let ftcawbdetails = {
              // awb: el.awb,
              allocationtype:'Last Mile',
              cash:el.cash
            }
            this.FTCAWB.push(ftcawbdetails)
          } 
          if(el.ftcsignedcashmemo == null && el.ftccashpayment) {
            let ftccashmemodetails = {
              awb: el.awb,
              allocationtype:'Last Mile',
              cash:el.ftccashpayment
            }
            this.FTCCashmemo.push(ftccashmemodetails)
          }
          if (el.invoicenumber) {
            let pendinginvoice = {
              invoicenumber: el.invoicenumber,
              ewbn: el.ewbnumber,
              allocationtype:'First Mile',
            }
            this.pendingInvoice.push(pendinginvoice)
          }
        })
        this.MPSArr = [...new Map(podarr.map((m) => [m.awb, m])).values()]
      }
       else{
        this.$alert(result.data.message, "", "error");
        this.ODOhidden = false
      }
      this.Loader = false
    },

    async getContractedVehicleList(hubid) {
      try {
        let InputPayload = {
          HubId: hubid
        };
        let result = await TripServices.getVehiclelist(InputPayload);
        let vehiclelist = result.data.data;
        return vehiclelist
      } catch (err) {
        console.log(err);
      }
    },

    checkODOKm(){
      if(this.VehicleCloseODOreading<0){
        this.VehicleCloseODOreading = ''
      }
      if(Number(this.VehicleCloseODOreading)>9999999999){
        this.ODOErr = 'Maximum 10 digits allowed for ODO reading'
      }else{
        this.ODOErr="";
      }
    },

    showEditPhysicalInvoice(i){
      this.showShipmentDropDown[i] = true
      this.showTable = false
      this.showTable = true
    },

    closeTripModal(){
      this.showCloseTripModal = false
    },

    async UpdatePhysicalInvoice(data,i){
      if(this.modifyphysicalinvoice<1 || Number(this.modifyphysicalinvoice) > Number(data.totalinvoice)){
        this.invoiceerr[i] = 'Invoice should less than total invoice'
        this.showTable = false
        this.showTable = true
        return false
      }
      this.isAWBScanning = true
      this.invoiceerr[i] = ''
      let input = {
        "tripid":this.parentObj.tripId,
        "awb":data.awb,
        "allocationtype":this.currentTab,
        "physicalinvoice":Number(this.modifyphysicalinvoice),
      }
      let result = await TripServices.UpdatePhysicalInvoice(input);
      if(result.data.code == 200){
        this.$alert(result.data.message, "", "success");
        this.getAWBDataForCloseTrip()
        this.showShipmentDropDown[i] = false
      } else{
        this.$alert(result.data.message, "", "error");
      }
      this.isAWBScanning = false
    },
    getTraceIP(input) {
      let data = 
        {
          "projectname": this.userdetail.project,
          "type": "web",
          "userid": this.userdetail.userid,
          "username": this.userdetail.username,
          "routeurl":'/TripManagement',
          "meta" : {
            "event" : `Close Trip`,
            "data" : input
          }
      }
      let result = iptracker.getTraceIP(data);
    },
    displayMPS(data){
      this.modalData=data.mpsslot.join(", ");
      this.showMPS = true
    },
	async getInvoiceData(){
		try{
		  this.isListingLoaded = true
		  let InputPayload = {
			  tripid: this.parentObj.tripId,
			  allocationtype: 'FM',
		  };
		  let result = await TripServices.getInvoiceData(InputPayload);
		  if(result.data.code == 200){
			if(this.currentTab == 'firstmile'){
			  this.firstmileInvoiceData = result.data.data
			  if(this.checkemptyawb){
				result.data.data.map(obj => {
					if(obj.awb==''){
						this.addAwb.push('');
					}
				})
			  }
			  this.checkemptyawb = false;
			}
			if(this.addAwb.length){
				this.subtabdisabledflag = true
			}else{
				$("#action").hide()
			}
		  }else{
			this.firstmileInvoiceData = []
		  }
		  this.isListingLoaded = false
		  this.isBasicInfoLoading = false
		  this.isListingLoaded = false
		}catch (err) {
		  console.log(err);
		  this.isListingLoaded = false
		}		
	  },
	  async SaveInvoiceData(data,index){
		try {
		  this.isListingLoaded = true
		  if(this.invoiceAwb[index] && this.invoiceAwb[index]!='' ){
			  await this.validateParentAwbNo(
			  this.invoiceAwb[index].toUpperCase().trim()
			  ).then((awbValidationResult) => {
				  if(!awbValidationResult.status) {
				  this.awbError = awbValidationResult.message;
				  this.$alertify.error(this.awbError);
				  this.isListingLoaded = false
				  return false;
				  }
			  });
		  }else{
			  this.$alertify.error("Please enter valid AWB");
			  this.isListingLoaded = false
			  return false;
		  }
		  let inputPayload = {
			  tripid: this.parentObj.tripId,
			  allocationtype: 'FM',
			  awb:this.invoiceAwb[index].toUpperCase().trim(),
			  invoiceid:data.id
		  };
		  let invoicedetails = [];
		  invoicedetails.push({
			  InvoiceNumber: data.invoicenumber,
			  InvoiceValue: data.invoicevalue,
			  EWBNumber: data.ewbnumber,
			  EWBExpiryDate: (data.expirydate) ? data.expirydate : null,
			  validatedresponse: (data.validatedresponse) ? data.validatedresponse : null,
			  IsEwbnExempted: data.isewbnexempted,
			  HsnCode: data.hsncode,
        invoiceaction: data.gstaction
		  });
		  inputPayload.invoicedetails = invoicedetails;
		  inputPayload.lastmodifiedby = this.userName;
		  inputPayload.clientid = data.clientid ;
		  let result = await TripServices.saveInvoiceData(inputPayload);
		  if(result.data.code == 200){
			  this.addAwb.pop();
			  await this.getInvoiceData();
			  this.$alertify.success("AWB scanned successfully");
		  }else{
			  this.$alertify.error("Please enter valid AWB");
		  }
		  if(!this.addAwb.length){
			this.subtabdisabledflag = false;
			$("#action").hide()
		  }
		  this.isListingLoaded = false
		} catch (error) {
		  this.isListingLoaded = false
		  console.log(error);
		}
	  },
	  isIntegerOnly: function(evt,index) {
		  evt = (evt) ? evt : window.event;
		  var charCode = (evt.which) ? evt.which : evt.keyCode;
		  if (charCode < 48 || (charCode > 57 && charCode <65) || (charCode >90 && charCode<97)||(charCode>122)) {
			evt.preventDefault();
		  } else {
			//this.addAwb[index] = true
			return true;
		  }
		},
		async validateParentAwbNo(parentAwbNo) {
		  return new Promise((resolve, reject) => {
			try {
			  let regexSurface = new RegExp('^9')
			  //let regexAir = new RegExp('^7' | '^6E' | '^I5');
			  let regexAir = new RegExp("^7|^7167");
			  let reverseAwb = new RegExp("R_", "i")
			  let regexAirAsia = new RegExp("^I5", "i");
			  let regexGoAir = new RegExp("^G8", "i");
			  let regexJetAirways = new RegExp("^9W", "i");
			  let regexVistara = new RegExp("^UK", "i");
			  let regexSpiceJet = new RegExp("^SG", "i");
			  let regexAirIndia = new RegExp("^AI", "i");
			  let regexGoAirCosta = new RegExp("^LB", "i");
			  let regexBlueDart = new RegExp("^BZ", "i");
			  let regexIndigo = new RegExp("^6E", "i");
			  if (parentAwbNo != "") {
				if (parentAwbNo.length >= 9 && parentAwbNo.length <= 16) {
				  if (regexSurface.test(parentAwbNo) || regexAir.test(parentAwbNo) || regexAirAsia.test(parentAwbNo) || regexGoAir.test(parentAwbNo) ||
						  regexJetAirways.test(parentAwbNo) || regexVistara.test(parentAwbNo) || regexSpiceJet.test(parentAwbNo) || regexAirIndia.test(parentAwbNo)
						  || regexGoAirCosta.test(parentAwbNo) || regexBlueDart.test(parentAwbNo) || reverseAwb.test(parentAwbNo) || regexIndigo.test(parentAwbNo)) {
							return resolve({ status: true, message: "" })
				  } else {
					return resolve({ status: false, message: "AWB Series does not match, AWB series for surface - (9) and Air - (7, 9W, G8, UK, SG, AI, LB, BZ, 6E, I5)" })
				  }
				} else {
				  return resolve({ status: false, message: "Invalid AWB No. (AWB No. must be min 10 or max 16 digit)" })
				}
			  } else {
				return resolve({ status: false, message: "AWB No Is Required." })
			  }
			} catch (error) {
			  reject("ERROR", error);
			}
		  })
		},
		//async removeInvoiceData(data,index){
		//	try {
		//		this.isListingLoaded = true
		//		console.log("FirstmileInvoice Data -----============",this.firstmileInvoiceData)
		//		this.firstmileInvoiceData.splice(index, 1);
		//		console.log("FirstmileInvoice Data<< -----============",this.firstmileInvoiceData)
				//await this.getInvoiceData();
		//		this.isListingLoaded = false
		//	  } catch (error) {
		//		this.isListingLoaded = false
		//		console.log(error);
		//	  }
		//}
    async loadScannedImageByScanner() {
      this.isGetDeviceLoader = true;      
      if (this.podDetail[this.selectedRowIndex].selectedScannedPodsToUploadS3 && this.podDetail[this.selectedRowIndex].selectedScannedPodsToUploadS3.length<=2 ) {
        const encodedString = encodeURIComponent(this.selectedScanner.id);
        let result = await TripServices.fetchScannedImage(encodedString)
       // Simulate an image loading delay (you would replace this with actual image loading logic)
       if (result && result.valid) {
         if (this.selectedPodImagesByScanner && this.selectedPodImagesByScanner.length<=2) {
           this.previewScannerImageUrl =  `data:image/jpeg;base64,${result.data.image}` ;
          //  this.selectedPodImagesByScanner.push(`data:image/jpeg;base64,${result.data.image}`)          
           this.isGetDeviceLoader = false;
           this.displayScannerImages = true
           this.viewScannedImage = true
           this.previewScannerImageUrl = ""
           this.podDetail[this.selectedRowIndex].selectedScannedPodsToUploadS3.push(`data:image/jpeg;base64,${result.data.image}`)
           this.selectedPodImagesByScanner = this.podDetail[this.selectedRowIndex].selectedScannedPodsToUploadS3
           this.viewScannerImageUploadButton = this.podDetail[this.selectedRowIndex].selectedScannedPodsToUploadS3.length >0 ? true :false
         } else {
          this.isGetDeviceLoader = false; 
           this.$alert("You Can Select only 3 Images",'Pod Validation', "error");
         }      
       } else {
         this.isGetDeviceLoader = false;
           this.displayScannerImages = true
           this.viewScannedImage = true
           this.$alert("Error While Scanning POD Image",'', "error")
       }
      } else {
        this.isGetDeviceLoader = false; 
        this.$alertify.error("You Can Select Only 3 Pod Images")
      }     
    },    
    async showMessage() {
      this.isScannerImageLoading = false
      console.log("Hello, after 2000 milliseconds!");
      this.viewScannedImage =true
      // this.$viewerApi({
      //   images: ["https://live-podimage.s3.ap-south-1.amazonaws.com/DocFile/94371190613854_P0.png"],
      // })
      // this.previewImageUrl = ["https://live-podimage.s3.ap-south-1.amazonaws.com/DocFile/94371190613854_P0.png"]
    },    
    confirmImage() {
      this.savePODDetailTest(this.selectedBadRemarks)
    },
  async rotateScannedImage() {
      console.log("check");
      this.rotation += 90;
    },
    zoomIn() {
      this.zoom += 0.1;
    },
    zoomOut() {
      if (this.zoom > 0.1) {
        this.zoom -= 0.1;
      }
    },
    closeImagePreview() {
      this.scanDocumentMdlFlag = false
      this.previewImageUrl = false
      this.isScannerImageLoading = false
    },
    resetZoomAndRotation() {
      this.zoom = 1;
      this.rotation = 0;
    },
    closeOverlay() {
      this.showImageFlag = false
    },
    handleWheel(event) {
      if (event.deltaY > 0) {
        this.zoomOut();
      } else {
        this.zoomIn();
      }
      event.preventDefault();
    },
    inited (viewer) {
      this.$viewer = viewer
    },
    previewImage() {
      this.showImageFlag =true
    },
    closeTakePhotoModal() {
      this.disabledActionButtonDiv = false
      this.viewCameraImageUploadButton = this.podDetail[this.selectedRowIndex].selectedCameraPodsToUploadS3
      this.imageData.image = ""
      this.selectedCamera = null
      this.viewCamera = false
      this.capturePhotoMdlFlag = false
      // this.selectedCameraCapturedPodImage = []
      this.stopCameraStream()
    },
    removeScannerCapturedImage(index) {   
      this.podDetail[this.selectedRowIndex].selectedScannedPodsToUploadS3.splice(index, 1);
      this.selectedPodImagesByScanner =this.podDetail[this.selectedRowIndex].selectedScannedPodsToUploadS3
      if (this.selectedPodImagesByScanner.length <= 0) {
        this.viewScannerImageUploadButton = this.podDetail[this.selectedRowIndex].selectedScannedPodsToUploadS3 > 0 ? true : false
        this.disabledActionButtonDiv = false
        this.displayCameraCapturedImages = false
        this.imageData.image = ''
        this.previewScannerImageUrl = ''
      }
    },
    removeCameraCapturedImage(index) {  
      this.podDetail[this.selectedRowIndex].selectedCameraPodsToUploadS3.splice(index, 1)
      this.selectedCameraCapturedPodImage =  this.podDetail[this.selectedRowIndex].selectedCameraPodsToUploadS3
      if (this.selectedCameraCapturedPodImage.length <= 0) {
        this.stopCameraStream()
        this.selectedCamera = null
        this.viewCameraImageUploadButton = this.podDetail[this.selectedRowIndex].selectedCameraPodsToUploadS3 > 0 ? true : false
        this.viewCameraImageUploadButton = false
        this.disabledActionButtonDiv = false
        this.displayCameraCapturedImages = false
        this.imageData.image = ''
      }
    },  
    closeScannerModal() {
      this.selectedScanner = null
      this.disabledActionButtonDiv = false
      this.previewScannerImageUrl = ''
      // this.selectedPodImagesByScanner = []
      this.scanDocumentMdlFlag = false
    },
    onClickCameraRefresh() {
      this.fetchCameraList()
    },
    onClickScannerRefresh() {
      this.fetchScannerList()
    },
   async  onChangeCamera(selectedEvent) {
     try {
       this.isCameraImageLoader = true
       this.disabledActionButtonDiv = true
        const constraints = {
          video: {
            deviceId: { exact: selectedEvent.deviceId },
            width: { min: 640, ideal: 1600 },
            height: { min: 400, ideal: 1200 },
            aspectRatio: { ideal: 1.7777777778 },
          }          
        };
        await navigator.mediaDevices.getUserMedia(constraints)
          .then(mediaStreamres => {
            this.viewCamera = true
            this.$nextTick(() => {
              this.$refs.video.srcObject = mediaStreamres;
              this.$refs.video.play()
              this.mediaStream = mediaStreamres 
            });
                                 
          }) 
          this.isCameraImageLoader = false
      } catch (error) {
        console.error('Error starting camera stream:', error);
      }
    }, 
    async  onChangeScanner(selectedEvent) {
      try {
        this.disabledActionButtonDiv = true;
        //  const constraints = {
        //    video: {
        //      deviceId: { exact: selectedEvent.deviceId },
        //      width: { min: 640, ideal: 1600 },
        //      height: { min: 400, ideal: 1200 },
        //      aspectRatio: { ideal: 1.7777777778 },
        //    }
        //  };
        //  await navigator.mediaDevices.getUserMedia(constraints)
        //    .then(mediaStreamres => {
        //      this.viewCamera = true
        //      this.$nextTick(() => {
        //        this.$refs.video.srcObject = mediaStreamres;
        //        this.$refs.video.play()
        //        this.mediaStream = mediaStreamres 
        //      });
                                  
        //  }) 
       } catch (error) {
         console.error('Error starting camera stream:', error);
       }
     },
    async onclickCaptureImage() {
      try {
        this.viewCamera = true
        const constraints = {
          video: { deviceId: { exact: this.selectedCamera } },
        };
        navigator.mediaDevices.getUserMedia(constraints)
        .then(mediaStream => {
                this.$refs.video.srcObject = mediaStream;
                this.$refs.video.play()
                this.mediaStream = mediaStream                   
        }) 
      } catch (error) {
        console.error('Error starting camera stream:', error);
      }      
      // navigator.mediaDevices.getUserMedia({video: true})
      // .then(mediaStream => {
      //         this.$refs.video.srcObject = mediaStream;
      //         this.$refs.video.play()
      //         this.mediaStream = mediaStream                   
      // })  
    },
    async uploadCameraCaptureImage() {
      if (this.scanDeliveredAWB) {
        this.isListingLoaded = true
        let uploadFile = this.selectedCaptureImage;
        this.imagearray = []
          let formData = new FormData();
          /*Add the form data we need to submit*/
          // for (let key in uploadFile) {
          //   if(key ){
          //     if(uploadFile[key].data != "image/jpeg" &&
          //   uploadFile[key].data != "image/jpg" && uploadFile[key].data != "image/png")
          //   {
          //     this.$alertify.error("Please upload only valid file format");
          //     this.isListingLoaded = false
          //     return false
          //   }
          //   }
          //   if (key == 'length' && uploadFile[key] > 3) {
          //     this.$alertify.error("Please upload maximum 3 file");
          //     this.isListingLoaded = false
          //     return false
          //   }
          //   if (uploadFile[key].size > (1024 * 1024 * 3)) {
          //     this.$alert(`${uploadFile[key].name} size is greater than 3MB`, "", "error");
          //     this.isListingLoaded = false
          //     return false
          //   } else {
          //     formData.append("file", uploadFile[key]);
          //   }
          // }
          formData.append("file", uploadFile);
          formData.append("awb", this.scanDeliveredAWB);
          let result = await TripServices.UploadcameraImage(formData)
          if (result.data.code == 200) {
            result.data.data.map(obj => {
              this.imagearray.push(obj.Location)
            })
            this.$alertify.success("Images uploaded successfully !");
			      this.imageerr = ''
          }
          else{
            this.$alertify.error("Images could not be uploaded.");
            this.isListingLoaded = false
          }
          this.isListingLoaded = false
      }
      else{
        this.isListingLoaded = true
        this.$alertify.error("Please scan AWB");
        // this.awbErr = 'Please Scan AWB'
        this.isListingLoaded = false
      }
    },
    async captureCameraImage() {
      try {
        this.isCameraImageLoader = true
        if (this.selectedCameraCapturedPodImage && this.selectedCameraCapturedPodImage.length <= 2) {
          const mediaStreamTrack = this.mediaStream.getVideoTracks()[0]
          const imageCapture = new window.ImageCapture(mediaStreamTrack)
          const captureSettings = {
            width: this.desiredWidth,
            height: this.desiredHeight,
            format: 'image/jpeg' // specify the desired image format
          };
          // Apply the settings to the ImageCapture object
          imageCapture.track.applyConstraints({ advanced: [captureSettings] })
          let reader = new FileReader();
          return await imageCapture.takePhoto().then(blob => {
            reader.readAsDataURL(blob)
            const canvas = document.createElement('canvas');
            canvas.width = this.$refs.video.videoWidth;
            canvas.height = this.$refs.video.videoHeight;
            canvas.getContext('2d').drawImage(this.$refs.video, 0, 0, canvas.width, canvas.height);
            canvas.toBlob(blob => {
              this.selectedCaptureImage = new File([blob], 'captured_image.png');
            }, 'image/png');
            this.displayCameraCapturedImages = true
            reader.onload = () => {
              this.imageData.image = reader.result;
              // this.selectedCameraCapturedPodImage.push(reader.result)
              this.imageData.image = ""
              this.isCameraImageLoader = false
              this.viewCameraImageUploadButton = true
              this.podDetail[this.selectedRowIndex].selectedCameraPodsToUploadS3.push(reader.result)
              this.selectedCameraCapturedPodImage = this.podDetail[this.selectedRowIndex].selectedCameraPodsToUploadS3
            }
            this.isCameraImageLoader =false
          })
        } else {
          this.imageData.image = ""
          this.isCameraImageLoader = false
          this.$alertify.error("You Can Select only 3 Pod Image");
        }
      } catch (error) {
        this.isCameraImageLoader = false
      }
     

    },
    stopCameraStream() {
      if (this.mediaStream) {
        const tracks = this.mediaStream.getTracks();
        tracks.forEach(track => track.stop());
        this.$refs.video.srcObject = null;
        this.mediaStream = null;
      }
    },
  rotateImage() {
      this.imageData.image_orientation = this.imageData.image_orientation + 90; 
    },
    cancelScannedImage() {
      this.previewScannerImageUrl = ''
    },
  cancelCameraCapturedImage() {
      this.imageData.image = null;
      this.showCameraModal = true;
      navigator.mediaDevices.getUserMedia({video: true})
      .then(mediaStream => {
              this.$refs.video.srcObject = mediaStream;
              this.$refs.video.play()
              this.mediaStream = mediaStream                   
      }) 
    },
    async uploadBrowsePodImage() {
      let formData = new FormData();
		  formData.append("awb", this.AWB)
		  formData.append("userName",this.userName)
      if(this.imageEvent){
				formData.append("checked", true)
				let uploadEvent = this.imageEvent
				if (uploadEvent) {
					let uploadFile = uploadEvent.target.files;
					this.imagearray = []
					/*Add the form data we need to submit*/
					for (let key in uploadFile) {
						if (key >= 0) {
							if (uploadFile[key].type != "image/jpeg" &&
								uploadFile[key].type != "image/jpg" && uploadFile[key].type != "image/png") {
								this.$alertify.error("Please upload only valid file format");
								this.isLoading = false
								return false
							}
						}
						if (key == 'length' && uploadFile[key] > 3) {
							this.$alertify.error("Please upload maximum 3 file");
							this.isLoading = false
							return false
						}
						if (uploadFile[key].size > (1024 * 1024 * 3)) {
							this.$alert(`${uploadFile[key].name} size is greater than 3MB`, "", "error");
							this.isLoading = false
							return false
						} else {
							formData.append("file", uploadFile[key]);
						}
					}
					//api --call
					let result = await TripServices.uploadPodData(formData)
          if (result.data.data.code == 200) {
            // let uploadResult = this.uploa
						this.$alertify.success("Images uploaded successfully !");
					} else {
						this.$alertify.error("Images could not be uploaded.");
						this.isLoading = false
					}
					this.isLoading = false
				} else {
					this.$alertify.error("Please Upload File again");
					this.isLoading = false
				}
				this.reUploadPodModal = false;
				this.resetReupload()
			}else{
				this.$alertify.error("Please select a file");
			}
    },
    uploadImage() {
      this.uploadCameraCaptureImage()
      // axios({ method: "POST", "url": API_IMAGE_ENDPOINT, "data": this.imageData})
      //   .then(response => {
      //           console.log("image upload response",response);
      //             this.response = response.data;    
      //          })
    },
    async uploadScannedImage() {
      if (this.scanDeliveredAWB) {
        this.isListingLoaded = true
        let uploadFile = event.target.files;
        this.imagearray = []
          let formData = new FormData();
          /*Add the form data we need to submit*/
          for (let key in uploadFile) {
            if(key >= 0 ){
              if(uploadFile[key].type != "image/jpeg" &&
            uploadFile[key].type != "image/jpg" && uploadFile[key].type != "image/png")
            {
              this.$alertify.error("Please upload only valid file format");
              this.isListingLoaded = false
              return false
            }
            }
            if (key == 'length' && uploadFile[key] > 3) {
              this.$alertify.error("Please upload maximum 3 file");
              this.isListingLoaded = false
              return false
            }
            if (uploadFile[key].size > (1024 * 1024 * 3)) {
              this.$alert(`${uploadFile[key].name} size is greater than 3MB`, "", "error");
              this.isListingLoaded = false
              return false
            } else {
              formData.append("file", uploadFile[key]);
            }
          }
          formData.append("awb", this.scanDeliveredAWB);
          let result = await TripServices.UploadPODImage(formData)
          if (result.data.code == 200) {
            result.data.data.map(obj => {
              this.imagearray.push(obj.Location)
            })
            this.$alertify.success("Images uploaded successfully !");
			this.imageerr = ''
          }
          else{
            this.$alertify.error("Images could not be uploaded.");
            this.isListingLoaded = false
          }
          this.isListingLoaded = false
      }
      else{
        this.isListingLoaded = true
        this.$alertify.error("Please scan AWB");
        // this.awbErr = 'Please Scan AWB'
        this.isListingLoaded = false
      }
    },
    openViewer(index) {
      this.$refs.viewer.view(index);
    },
    async fetchCameraList() {
      try {
        await navigator.mediaDevices.getUserMedia({ video: true });
        this.isGetDeviceLoader = true
        const devices = await navigator.mediaDevices.enumerateDevices();
        this.printerList = devices.filter(device => device.kind === 'videoinput');
        this.isGetDeviceLoader = false
      } catch (error) {
        this.isGetDeviceLoader = false
        console.error('Error fetching camera list:', error);
      }
    }, 
    setname(id, name){
      return name+id;
    },
    async fetchScannerList() {
      try {
        this.isGetDeviceLoader = true
        this.scannerList = []
        let getScannerList = await TripServices.fetchInstalledScannerList()
        if (getScannerList.valid) {
          const scannerList = getScannerList.data.scanners.split('\n').filter(line => line.startsWith('device'));
          const scanners = scannerList.map(line => {
              const match = line.match(/device\s`(.*)'/);
              return match ? match[1] : null;
          }).filter(scanner => scanner !== null);
          var select = document.getElementById("scannerSelect");
          scanners.forEach(scanner => {
            this.scannerList.push({id:scanner,label:scanner})
          });
          this.isGetDeviceLoader = false
      }
      } catch (error) {
        this.isGetDeviceLoader = false
        console.error('Error fetching camera list:', error);
      }
    },
    downloadImage(index) {
      // Implement image download logic here
      // Example using FileSaver.js:
      const image = this.images[index];
      const xhr = new XMLHttpRequest();
      xhr.responseType = 'blob';
      xhr.onload = () => {
        const blob = new Blob([xhr.response], { type: 'image/jpeg' });
        saveAs(blob, `image_${index + 1}.jpg`);
      };
      xhr.open('GET', image);
      xhr.send();
    },

    async savePODDetailTest(selectedRemark){	
      let podBadRemark = []	
      if(selectedRemark){
      for (let k = 0; k < selectedRemark.length; k++) {
        const element = selectedRemark[k]; 
        let badRemark = this.podRemarkArray.find(value => value.id == element)                        
        if (badRemark) {
        podBadRemark.push(badRemark.remark)
        }                                                       
      }
      }
        if(this.checkErrForPOD()){
          return false
        }
      this.saveDetailsFlag=true;
        this.imgOpenFlagFunction();
        this.isListingLoaded = true
        let input = {
          "tripid":this.parentObj.tripId,
          "parentawb":this.scanDeliveredAWB,
          "allocationtype":this.currentTab=='lastmile'?"LM":"FM",
          "podquality":this.PODQC,
          "comments":this.Comments
        }
        if(this.PODQC == 'bad'){
          input.badpodreason= podBadRemark.toString()
          input.podimages= [this.previewImageUrl]
        }
        else
        input.podimages= [this.previewImageUrl]
        let result = await TripServices.savePOD(input);
        if(result.data.code == 200){
          this.$alertify.success(result.data.message);
          this.clearData()
          this.getPODDetailAgainstTrip()
          this.toggleCheck(2);
          this.accordianTab[2] = true
          // this.accordianTab[1] = false;
          // this.subaccordianTab[1]=true;
        }else{
          this.$alertify.error(result.data.message);
        }
        this.isListingLoaded = false
      this.viewpod = false
      this.clearData()
      this.saveDetailsFlag=false;
      },
  }
}



// WEBPACK FOOTER //
// ./src/modules/firstAndLastmilemanagement/views/TripManagement/CreateTripManagement/closeTrip/closeTrip.component.js